(function () {
  if (window.FrostixBonusClub) return;

  var BONUS_BINDING_KEY = 'frostix_bonus_points';
  var BONUS_REVISION_KEY = 'frostix_bonus_cart_revision';
  var SESSION_STATE_KEY = 'frostix:bonus-club-state-v2';
  var CHECKOUT_RETURN_HINT_KEY = 'frostix:bonus-club-checkout-return-v1';
  var CHECKOUT_RETURN_HINT_MAX_AGE_MILLISECONDS = 60_000;
  var CHECKOUT_RETURN_DIAGNOSTIC_KEY = 'frostix:bonus-club-checkout-return-diagnostic-v1';
  var EMAIL_CONFIRMATION_PENDING_KEY = 'frostix:bonus-club-email-confirmation-pending-v1';
  var ENROLLMENT_SOURCE_KEY = 'frostix:bonus-club-enrollment-source-v1';
  var ENROLLMENT_SOURCE_MAX_AGE_MILLISECONDS = 3_600_000;
  var MEMBERSHIP_CHANGED_EVENT = 'frostix:bonus-club-membership-changed';
  var REDEMPTION_CHANGED_EVENT = 'frostix:bonus-club-redemption-changed';
  var CUSTOMER_STATUS_POLL_INTERVAL_MILLISECONDS = 2_000;
  var CUSTOMER_STATUS_WATCH_MILLISECONDS = 60_000;
  var EMAIL_CONFIRMATION_RESEND_COOLDOWN_MILLISECONDS = 60_000;
  var EMAIL_CONFIRMATION_PENDING_MAX_AGE_MILLISECONDS = 86_400_000;
  var HISTORY_PAGE_SIZE = 20;
  var technicalConfiguration = window.FrostixBonusClubTechnicalConfig || {};
  function timeoutSetting(key, fallback) {
    var value = Number(technicalConfiguration[key]);
    return Number.isSafeInteger(value) && value > 0 && value <= 60_000 ? value : fallback;
  }
  var REQUEST_TIMEOUT_MILLISECONDS = timeoutSetting('requestTimeoutMs', 15_000);
  var READ_TIMEOUT_MILLISECONDS = timeoutSetting('readTimeoutMs', 12_000);
  var FINANCIAL_BARRIER_MILLISECONDS = timeoutSetting('financialBarrierMs', 20_000);
  var SUMMARY_FRESHNESS_MILLISECONDS = 1_000;
  var cartAttributeQueue = Promise.resolve();
  var initialCartRead = null;
  var initialCartReadUsed = false;
  var initialCartContextReady = false;
  var resolveCartActionsReady;
  var cartActionsReady = new Promise(function (resolve) { resolveCartActionsReady = resolve; });
  var readRequestCounts = {summary: 0, preview: 0, initial: 0, product_preview: 0};

  function checkoutReturnDiagnostic(stage, checks) {
    try {
      if (window.location.hostname !== 'frostix-loyalty-dev.myshopify.com' ||
          typeof console === 'undefined' || typeof console.info !== 'function') return;
      var row = {stage: stage};
      Object.keys(checks || {}).forEach(function (key) {
        if (/^(bonusEnabled|customerPresent|statePresent|referrerPresent|referrerValid|sameOrigin|checkoutReferrer|scopeMatches|prepared|checkoutState|unknownClear|pendingClear|settlementClear|budgetValid|recoveryMatches|proofMatches|schemaValid|ageValid|scopeValid|approvalValid|bindingValid|revisionValid|tokenValid|generationValid|intentValid|referrerMatches|cartPathValid|rootMatches|rootCanonicalMatches|cartMatches|cartShapeValid|approvalMatches|markersMatch|contextMatches|summaryOk|ownerMatches|summaryFresh|proofValid|authorizationActive|authorizationCheckout|cartAuthorized|applied|fingerprintMatches|allocationMatches)$/.test(key) && typeof checks[key] === 'boolean') row[key] = checks[key];
      });
      console.info('[Frostix Checkout Return] ' + JSON.stringify(row));
    } catch (_error) {}
  }

  function checkoutReturnRootPath(path) {
    return typeof path === 'string' && path.charAt(0) === '/' ? path.replace(/\/$/, '') || '/' : null;
  }

  function navigationReadTiming(entry) {
    if (!entry) return null;
    function span(start, end) {
      return Number.isFinite(start) && start >= 0 && Number.isFinite(end) && end > 0 && end >= start && end <= Number.MAX_SAFE_INTEGER
        ? Math.round((end - start) * 1000) / 1000 : null;
    }
    function point(value) {
      return Number.isFinite(value) && value >= 0 && value <= Number.MAX_SAFE_INTEGER ? Math.round(value * 1000) / 1000 : null;
    }
    var protocol = entry.nextHopProtocol;
    return {
      startTimeMs: point(entry.startTime),
      fetchStartMs: point(entry.fetchStart),
      workerStartMs: point(entry.workerStart),
      unloadMs: span(entry.unloadEventStart, entry.unloadEventEnd),
      redirectMs: span(entry.redirectStart, entry.redirectEnd),
      redirectCount: Number.isInteger(entry.redirectCount) && entry.redirectCount >= 0 && entry.redirectCount <= 65535 ? entry.redirectCount : null,
      preFetchMs: span(entry.startTime, entry.fetchStart),
      preRequestMs: span(entry.fetchStart, entry.requestStart),
      dnsMs: span(entry.domainLookupStart, entry.domainLookupEnd),
      // Includes TLS; collapsed phases do not by themselves prove connection reuse.
      connectMs: span(entry.connectStart, entry.connectEnd),
      tlsMs: entry.secureConnectionStart > 0 && entry.secureConnectionStart >= entry.connectStart
        ? span(entry.secureConnectionStart, entry.connectEnd) : null,
      requestWaitMs: span(entry.requestStart, entry.responseStart),
      downloadMs: span(entry.responseStart, entry.responseEnd),
      nextHopProtocol: ['http/1.0', 'http/1.1', 'h2', 'h3'].includes(protocol) ? protocol : protocol ? 'other' : 'unavailable',
      navType: ['navigate', 'reload', 'back_forward', 'prerender'].includes(entry.type) ? entry.type : 'unknown',
      transferSize: Number.isSafeInteger(entry.transferSize) && entry.transferSize >= 0 ? entry.transferSize : null,
    };
  }

  function readTiming(stage, detail) {
    try {
      if (window.FrostixCartObservability && (stage === 'summary_accepted' || stage === 'preview_accepted')) {
        window.FrostixCartObservability.ready(stage === 'summary_accepted' ? 'summary' : 'earning_preview');
      }
    } catch (_observationError) {}
    try {
      if (!/[?&]frostix_bonus_debug=1(?:&|$)/.test(String(window.location && window.location.search || '')) ||
          typeof console === 'undefined' || typeof console.info !== 'function') return;
      if (!/^(html_response_end|cart_ready|summary_accepted|preview_accepted|initial_(waiting|legacy|claimed|unsupported)|request_(sent|response|failed))$/.test(stage)) return;
      var clock = window.performance;
      var navigation = clock && clock.getEntriesByType && clock.getEntriesByType('navigation')[0];
      var row = {stage: stage,
        pageElapsedMs: clock && typeof clock.now === 'function' ? Math.round(clock.now() * 1000) / 1000 : null,
        htmlResponseEndMs: navigation && Number.isFinite(navigation.responseEnd) ? navigation.responseEnd : null};
      if (stage === 'html_response_end' || stage === 'cart_ready') row.navigationTiming = navigationReadTiming(navigation);
      if (detail && Object.hasOwn(readRequestCounts, detail.category)) {
        row.category = detail.category;
        row.requestCount = readRequestCounts[detail.category];
        row.httpStatus = Number.isInteger(detail.httpStatus) ? detail.httpStatus : null;
        row.swSupported = null;
        row.swControlled = null;
        try {
          var browser = window.navigator;
          row.swSupported = Boolean(browser && 'serviceWorker' in browser);
          row.swControlled = row.swSupported ? Boolean(browser.serviceWorker.controller) : false;
        } catch (_error) {}
      }
      console.info('[Frostix Bonus Read] ' + JSON.stringify(row));
    } catch (_error) {}
  }
  readTiming('html_response_end');

  function readRequestTiming(category, outcome, status) {
    if (!Object.hasOwn(readRequestCounts, category) || !['sent', 'response', 'failed'].includes(outcome)) return;
    if (outcome === 'sent') readRequestCounts[category] += 1;
    readTiming('request_' + outcome, {category: category, requestCount: readRequestCounts[category],
      httpStatus: Number.isInteger(status) ? status : null});
  }

  function cartInitialEnabled() {
    try {
      var values = new URLSearchParams(window.location.search).getAll('frostix_bonus_cart_initial');
      return window.location.hostname === 'frostix-loyalty-dev.myshopify.com' && values.length === 1 && values[0] === '1';
    } catch (_error) { return false; }
  }

  function cartInitialIdentity(cart) {
    return JSON.stringify([cart && cart.token, cartBinding(cart), cartRevision(cart), cartFingerprint(cart)]);
  }

  function cleanInitialCart(cart, scope, acceptingSummary) {
    var widget = manager.firstAuthenticatedWidget();
    return Boolean(widget && widget.dataset.context === 'cart' && /^[1-9]\d*$/.test(String(scope)) &&
      manager.currentCustomerScope() === scope && manager.sessionCustomerScope === scope &&
      !Array.from(manager.widgets).some(function (entry) { return entry.dataset.context === 'account'; }) &&
      !(document.querySelector && document.querySelector('frostix-bonus-club[data-context="account"]')) &&
      cart && typeof cart.token === 'string' && cart.token && !cartHasAuthorization(cart) &&
      !manager.binding && !manager.reservationId && !manager.nativeAuthorization && !manager.pendingApply &&
      !manager.pendingRevocation && !manager.pendingLeaseOperation && !manager.authorizationRecovery &&
      !manager.applied && !manager.unknownOperation && !manager.sessionOwnerMismatch && !manager.legacySessionUnverified &&
      !manager.nativeBudgetInvalid && !manager.settlementPending && !manager.checkoutPrepared && !manager.operation &&
      !manager.financialPromise && (acceptingSummary || !(window.CartStore && window.CartStore.hasPending && window.CartStore.hasPending())) &&
      manager.summaryAuthorizationContext(cart) === null);
  }

  function initialCartGate() {
    if (!cartInitialEnabled()) return null;
    if (initialCartRead) return initialCartRead;
    if (initialCartReadUsed) return null;
    initialCartReadUsed = true;
    var gate = {state: 'waiting', controller: new AbortController(), summary: null, producer: null};
    gate.ready = new Promise(function (resolve) { gate.resolve = resolve; });
    gate.timer = setTimeout(function () { declineInitialCart(gate); }, 50);
    initialCartRead = gate;
    readTiming('initial_waiting');
    return gate;
  }

  function declineInitialCart(gate) {
    if (!gate || gate.state !== 'waiting') return;
    gate.state = 'legacy';
    clearTimeout(gate.timer);
    gate.resolve(null);
    readTiming('initial_legacy');
  }

  function initialRule(value) {
    return Boolean(value && typeof value.id === 'string' && value.id &&
      Number.isSafeInteger(value.revision) && value.revision > 0 && /^[A-Z]{3}$/.test(String(value.currencyCode)));
  }

  function validInitialPreview(result) {
    return Boolean(result && result.ok === true && result.surface === 'cart' && initialRule(result.rule) &&
      (result.status === 'unavailable' && typeof result.reason === 'string' ||
        result.status === 'ready' && result.award && Number.isSafeInteger(result.award.earnedPointsSnapshot) &&
        result.award.earnedPointsSnapshot >= 0));
  }

  function initialCartResult(gate, result) {
    if (initialCartRead !== gate || gate.controller.signal.aborted ||
        !cleanInitialCart(authoritativeCart(), gate.summary.scope, true) ||
        gate.summary.context !== null || manager.proxyBase() !== gate.summary.proxyBase ||
        // A quantity change invalidates the preview, but the same owner's balance
        // can still pass the existing summary guards for this clean context.
        String(authoritativeCart() && authoritativeCart().token) !== String(gate.summary.cart.token) ||
        !validInitialPreview(result)) throw new Error('bonus_club_initial_cart_unconfirmed');
    if (!Object.hasOwn(result, 'cartInitial')) return null;
    var envelope = result.cartInitial;
    var summary = envelope && envelope.summary;
    var rule = summary && summary.redemption && summary.redemption.rule;
    if (!envelope || envelope.schemaVersion !== 1 || !summary || summary.ok !== true ||
        !summary.customer || summary.customer.authenticated !== true ||
        summary.customer.id !== 'gid://shopify/Customer/' + gate.summary.scope || !initialRule(rule) ||
        rule.id !== result.rule.id || rule.revision !== result.rule.revision || rule.currencyCode !== result.rule.currencyCode ||
        result.status === 'ready' && result.rule.currencyCode !== gate.producer.evidence.currency_code) throw new Error('bonus_club_initial_cart_unconfirmed');
    return summary;
  }

  function claimInitialCart(gate) {
    if (!gate || gate.state !== 'waiting' || !initialCartContextReady || !gate.summary || !gate.producer) return;
    var producer = gate.producer;
    if (!cleanInitialCart(gate.summary.cart, gate.summary.scope) || gate.summary.context !== null ||
        producer.scope !== gate.summary.scope || producer.proxyBase !== gate.summary.proxyBase ||
        producer.source.connected === false || producer.signal.aborted ||
        producer.identity !== cartInitialIdentity(gate.summary.cart) ||
        producer.identity !== cartInitialIdentity(authoritativeCart())) {
      declineInitialCart(gate);
      return;
    }
    var body = Object.assign({}, producer.evidence, {cart_initial: {schemaVersion: 1, summaryContext: null}});
    try {
      if (!Array.isArray(body.lines) || body.lines.length > 250 || typeof TextEncoder !== 'function' ||
          new TextEncoder().encode(JSON.stringify(body)).length > 64 * 1024) {
        declineInitialCart(gate);
        return;
      }
    } catch (_error) { declineInitialCart(gate); return; }
    gate.state = 'claimed';
    clearTimeout(gate.timer);
    gate.body = body;
    gate.resolve(gate);
    readTiming('initial_claimed');
  }

  function initialSummaryRequest(cart, context) {
    if (!cartInitialEnabled()) return null;
    if (!cleanInitialCart(cart, manager.sessionCustomerScope)) {
      declineInitialCart(initialCartGate());
      return null;
    }
    var gate = initialCartGate();
    if (!gate || gate.summary) return null;
    gate.summary = {cart: cart, context: context, scope: manager.sessionCustomerScope, proxyBase: manager.proxyBase()};
    claimInitialCart(gate);
    return gate.ready.then(function (claimed) {
      if (!claimed) return requestJson(summaryUrl(manager.proxyBase(), cart, null, context));
      return gate.producer.request(gate.controller.signal, gate.body, true).then(function (result) {
        gate.state = 'closed';
        var summary = initialCartResult(gate, result);
        if (summary) return summary;
        // A valid old preview without the marker definitively did not implement
        // the opt-in. Reuse that preview; only the missing GET is needed.
        readTiming('initial_unsupported');
        return requestJson(summaryUrl(manager.proxyBase(), cart, null, context));
      }).finally(function () { gate.state = 'closed'; });
    });
  }

  function initialPreviewRequest(source, cart, evidence, signal, request, inFlightOnly) {
    if (!cartInitialEnabled() || !source || !source.dataset || evidence.surface !== 'cart' ||
        !source.evidence || source.evidence.surface !== 'cart' || typeof request !== 'function' || !signal ||
        !/^[1-9]\d*$/.test(String(source.dataset.customerScope)) || !cart || !cart.token ||
        initialCartContextReady && !cleanInitialCart(cart, String(source.dataset.customerScope)) ||
        inFlightOnly && (!initialCartRead || initialCartRead.state !== 'claimed')) return null;
    var gate = initialCartGate();
    var producer = {source: source, cart: cart, evidence: evidence, identity: cartInitialIdentity(cart),
      scope: String(source.dataset.customerScope), proxyBase: String(source.dataset.proxyBase || '').replace(/\/$/, ''),
      signal: signal, request: request};
    if (!gate || !['waiting', 'claimed'].includes(gate.state)) return null;
    if (gate.producer && (gate.producer.identity !== producer.identity || gate.producer.scope !== producer.scope ||
        gate.producer.proxyBase !== producer.proxyBase || JSON.stringify(gate.producer.evidence) !== JSON.stringify(evidence))) return null;
    if (!gate.producer) gate.producer = producer;
    claimInitialCart(gate);
    return gate.ready.then(function (claimed) {
      if (signal.aborted) throw Object.assign(new Error('cancelled'), {name: 'AbortError'});
      if (!claimed) return request(signal, evidence, false);
      return request(signal, gate.body, true).then(function (result) {
        initialCartResult(gate, result);
        return result;
      });
    });
  }

  function bonusOperationTrace(operation) {
    var started = Date.now();
    var currentStage = 'start';
    var observation = null;
    var observer = null;
    try {
      if (window.FrostixCartObservability && ['apply', 'remove'].includes(operation)) {
        observer = window.FrostixCartObservability;
      }
    } catch (_observationError) {}
    var observationOutcome = null;
    var record = function (stage, error) {
      if (stage) currentStage = stage;
      if (observation && (error || stage === 'confirmed' || stage === 'unconfirmed')) {
        observationOutcome = error ? bonusObservationFailure(error) : stage === 'confirmed' ? 'ok' : 'unconfirmed';
      }
      try {
        if (!/[?&]frostix_bonus_debug=1(?:&|$)/.test(String(window.location && window.location.search || '')) ||
            typeof console === 'undefined' || typeof console.info !== 'function') return;
        var code = error && typeof error.message === 'string' && /^bonus_club_[a-z0-9_]+$/.test(error.message) ? error.message :
          error && error.name === 'TypeError' ? 'type_error' : error && error.name === 'AbortError' ? 'aborted' :
            error ? 'operation_error' : null;
        console.info('[Frostix Bonus] ' + JSON.stringify({operation: operation, stage: currentStage, elapsedMs: Date.now() - started,
          errorCode: code, errorStatus: error && Number.isInteger(error.status) ? error.status : null}));
      } catch (_traceError) {}
    };
    if (observer) {
      record.startObservation = function () {
        try { observation = observer.startOperation(operation); } catch (_observationError) {}
      };
      record.captureObservationState = function (unknown) {
        if (unknown) observationOutcome = 'unconfirmed';
      };
      record.finishObservation = function () {
        bonusObservationEvent(observation, 'finish', observationOutcome || 'unconfirmed');
      };
    }
    return record;
  }

  function bonusObservationEvent(observation, event, value) {
    try { if (observation) observation[event](value); } catch (_observationError) {}
  }

  function bonusObservationFailure(error) {
    if (error && error.name === 'TimeoutError') return 'timeout';
    if (error && error.name === 'AbortError') return 'aborted';
    if (error && error.status === 0 && error.message === 'Network failed') return 'network_error';
    if (error && error.status === 422 && error.description === 'PROMO_NOT_APPLICABLE') return 'not_applicable';
    if (error && error.status === 422 && error.description === 'PROMO_REMOVE_FAILED') return 'unconfirmed';
    if (error && Number.isInteger(error.status) && error.status >= 400) return 'http_error';
    if (error && error.name === 'TypeError') return 'network_error';
    return 'other_error';
  }

  function bonusHttpResourceTiming(url, minimumStart, maximumStart) {
    try {
      var clock = window.performance;
      if (!Number.isFinite(minimumStart) || !Number.isFinite(maximumStart) || maximumStart < minimumStart ||
          !clock || typeof clock.getEntriesByName !== 'function') return null;
      var name = new URL(url, window.location.href).href;
      var entries = clock.getEntriesByName(name, 'resource').filter(function (entry) {
        return entry.name === name && entry.initiatorType === 'fetch' &&
          Number.isFinite(entry.startTime) && entry.startTime >= minimumStart && entry.startTime <= maximumStart;
      });
      if (entries.length !== 1 || !Number.isFinite(entries[0].responseEnd) || entries[0].responseEnd <= 0) return null;
      var entry = entries[0], result = {};
      ['startTime', 'workerStart', 'fetchStart', 'domainLookupStart', 'domainLookupEnd', 'connectStart',
        'secureConnectionStart', 'connectEnd', 'requestStart', 'responseStart', 'responseEnd', 'duration'].forEach(function (key) {
        var value = entry[key];
        result[key + 'Ms'] = Number.isFinite(value) && value >= 0 && value <= Number.MAX_SAFE_INTEGER
          ? Math.round(value * 1000) / 1000 : null;
      });
      result.nextHopProtocol = /^(?:h[23](?:-\d{1,3})?|http\/1\.[01])$/.test(entry.nextHopProtocol)
        ? entry.nextHopProtocol : null;
      return result;
    } catch (_resourceTimingError) { return null; }
  }

  var httpTraceCall = 0;
  function bonusHttpTrace(url) {
    try {
      if (!/[?&]frostix_bonus_debug=1(?:&|$)/.test(String(window.location && window.location.search || '')) ||
          typeof console === 'undefined' || typeof console.info !== 'function') return null;
      var clock = window.performance;
      if (!clock || typeof clock.now !== 'function' || httpTraceCall >= Number.MAX_SAFE_INTEGER) return null;
      var started = clock.now();
      if (!Number.isFinite(started) || started < 0 || started > Number.MAX_SAFE_INTEGER) return null;
      var last = started;
      var call = ++httpTraceCall;
      var path = String(url).split(/[?#]/)[0];
      var match = /\/(summary|history|join|unsubscribe|redemption-apply|redemption-remove|redemption-renew|redemption-checkout-start)$/.exec(path);
      var route = match ? match[1].replace(/-/g, '_') : /\/cart\/update\.js$/.test(path) ? 'cart_update'
        : /\/cart\.js$/.test(path) ? 'cart_read' : 'other';
      var resourceTrace = ['frostix-loyalty-dev.myshopify.com', 'frostix.de', 'frostix-store.myshopify.com'].includes(window.location.hostname) && route !== 'other';
      var operation = manager && ['apply', 'remove', 'checkout', 'promo', 'activity', 'terminal_cleanup'].includes(manager.operation)
        ? manager.operation : 'background';
      return function (attempt) {
        if (!Number.isInteger(attempt) || attempt < 1 || attempt > 2) return null;
        var sent = null;
        var dispatched = null;
        var signal = null;
        var status = null;
        var classification = null;
        var responseRequestId = null;
        var backendElapsedMs = null;
        var terminal = false;
        var record = function (stage, value) {
          try {
            if (!['send', 'response', 'complete', 'failed', 'retry_wait', 'retry_resume'].includes(stage)) return;
            if (stage === 'send') signal = value;
            if (stage === 'response') {
              status = value && Number.isInteger(value.status) && value.status >= 100 && value.status <= 599 ? value.status : null;
              if (resourceTrace) {
                try {
                  var responseId = value && value.headers && (value.headers.get('x-frostix-timing-id') || value.headers.get('x-request-id'));
                  responseRequestId = typeof responseId === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(responseId)
                    ? responseId.toLowerCase() : null;
                  var backendDuration = value && value.headers && value.headers.get('x-frostix-timing-ms');
                  backendElapsedMs = typeof backendDuration === 'string' && /^\d{1,6}$/.test(backendDuration) ? Number(backendDuration) : null;
                } catch (_requestIdError) {}
              }
              if (terminal) stage = 'late_response';
            }
            if (stage === 'failed') {
              terminal = true;
              var name;
              try { name = value && value.name; } catch (_nameError) {}
              classification = name === 'TypeError' ? 'type_error' : name === 'TimeoutError' ? 'timeout'
                : name === 'AbortError' ? 'aborted' : status !== null && status >= 400 ? 'http_error'
                  : status !== null ? 'invalid_response' : 'other';
            }
            if (stage === 'complete') terminal = true;
            var now = clock.now();
            if (!Number.isFinite(now) || now < 0 || now > Number.MAX_SAFE_INTEGER) return;
            now = last = Math.max(last, now);
            if (stage === 'send') sent = now;
            var rounded = function (number) { return Math.round(number * 1000) / 1000; };
            var aborted = null;
            try { if (signal) aborted = Boolean(signal.aborted); } catch (_signalError) {}
            var row = {call: call, attempt: attempt, operation: operation, route: route, stage: stage,
              pageElapsedMs: rounded(now), callElapsedMs: rounded(now - started), attemptElapsedMs: sent === null ? null : rounded(now - sent),
              httpStatus: status, classification: classification, aborted: aborted,
              retryDelayMs: ['retry_wait', 'retry_resume'].includes(stage) && Number.isFinite(value) && value >= 500 && value <= 5_000 ? rounded(value) : null};
            if (resourceTrace && ['complete', 'failed'].includes(stage)) {
              row.resourceTiming = bonusHttpResourceTiming(url, sent, dispatched);
              row.responseRequestId = responseRequestId;
              row.backendElapsedMs = backendElapsedMs;
            }
            console.info('[Frostix Bonus HTTP] ' + JSON.stringify(row));
          } catch (_httpTraceError) {}
        };
        if (resourceTrace) record.dispatched = function () {
          try {
            var now = clock.now();
            if (Number.isFinite(now) && now >= sent && now <= Number.MAX_SAFE_INTEGER) dispatched = now;
          } catch (_dispatchTraceError) {}
        };
        return record;
      };
    } catch (_httpTraceError) { return null; }
  }

  async function requestJson(url, options) {
    options = options || {};
    if (/\/redemption-(apply|remove|renew|checkout-start)$/.test(String(url))) manager.assertSessionMutationAllowed();
    var headers = Object.assign({'Accept': 'application/json'}, options.headers || {});
    if (options.body && !headers['Content-Type']) headers['Content-Type'] = 'application/json';
    var requestOptions = Object.assign({credentials: 'same-origin'}, options, {headers: headers});
    delete requestOptions.timeoutMs;
    var mayRetry = !options.method || options.method === 'GET' ||
      /\/redemption-(apply|remove|renew|checkout-start)$/.test(String(url));
    var traceRequest = bonusHttpTrace(url);
    for (var attempt = 0; ; attempt += 1) {
      const traceAttempt = traceRequest ? traceRequest(attempt + 1) : null;
      let observation = null;
      try {
        var controller = new AbortController();
        var parentSignal = options.signal;
        var cancel = function () { controller.abort(); };
        if (parentSignal && parentSignal.aborted) throw Object.assign(new Error('cancelled'), {name: 'AbortError'});
        if (parentSignal) parentSignal.addEventListener('abort', cancel, {once: true});
        var timeoutId;
        var rejectOnAbort;
        var loaded;
        try {
          var summaryRead = String(url).split('?')[0].endsWith('/summary');
          if (summaryRead) readRequestTiming('summary', 'sent');
          if (traceAttempt) traceAttempt('send', controller.signal);
          try {
            if (window.FrostixCartObservability) observation = window.FrostixCartObservability.startRequest(url, options.method || 'GET', attempt + 1);
          } catch (_observationError) {}
          var networkRequest = fetch(url, Object.assign({}, requestOptions, {signal: controller.signal}));
          if (traceAttempt && traceAttempt.dispatched) traceAttempt.dispatched();
          loaded = await Promise.race([
            networkRequest.then(async function (response) {
              bonusObservationEvent(observation, 'response', response.status);
              if (traceAttempt) traceAttempt('response', response);
              if (summaryRead) readRequestTiming('summary', 'response', response.status);
              var body = await response.json().catch(function () { return null; });
              if (controller.signal.aborted) throw Object.assign(new Error('cancelled'), {name: 'AbortError'});
              return {response: response, body: body};
            }),
            new Promise(function (_resolve, reject) {
              timeoutId = setTimeout(function () {
                controller.abort();
                reject(Object.assign(new Error('bonus_club_request_timeout'), {name: 'TimeoutError'}));
              }, Number(options.timeoutMs) > 0 ? Number(options.timeoutMs)
                : options.method === 'POST' ? REQUEST_TIMEOUT_MILLISECONDS : READ_TIMEOUT_MILLISECONDS);
              rejectOnAbort = function () {
                reject(Object.assign(new Error('cancelled'), {name: 'AbortError'}));
              };
              if (parentSignal) parentSignal.addEventListener('abort', rejectOnAbort, {once: true});
            }),
          ]);
        } finally {
          clearTimeout(timeoutId);
          if (parentSignal) parentSignal.removeEventListener('abort', cancel);
          if (parentSignal) parentSignal.removeEventListener('abort', rejectOnAbort);
        }
        var response = loaded.response;
        var body = loaded.body;
        if (!response.ok || !body) {
          bonusObservationEvent(observation, 'finish', !response.ok ? 'http_error' : 'invalid_response');
          var error = new Error('bonus_club_request_failed');
          error.status = response.status;
          error.body = body;
          throw error;
        }
        bonusObservationEvent(observation, 'finish', 'ok');
        if (traceAttempt) traceAttempt('complete');
        return body;
      } catch (error) {
        if (observation) bonusObservationEvent(observation, 'finish', bonusObservationFailure(error));
        if (traceAttempt) traceAttempt('failed', error);
        if (summaryRead) readRequestTiming('summary', 'failed', error && error.status);
        var connectionFailed = error && (error.name === 'TypeError' ||
          [429, 502, 503, 504].includes(error.status));
        if (!mayRetry || attempt >= 1 || !connectionFailed) throw error;
        var retryAfter = response && response.headers && response.headers.get('Retry-After');
        if (Number(retryAfter) * 1_000 > 5_000) throw error;
        var retryDelay = Math.max(500, Math.min(5_000, Number(retryAfter) * 1_000 || 0));
        if (traceAttempt) traceAttempt('retry_wait', retryDelay);
        await wait(retryDelay);
        if (traceAttempt) traceAttempt('retry_resume', retryDelay);
      }
    }
  }

  function cartUpdateUrl() {
    var base = '/cart/update';
    if (typeof routes !== 'undefined' && routes.cart_update_url) base = routes.cart_update_url;
    return base.indexOf('.js') === -1 ? base + '.js' : base;
  }

  function authoritativeCart() {
    return window.CartStore && typeof window.CartStore.getServerCart === 'function'
      ? window.CartStore.getServerCart()
      : null;
  }

  function enteredCodes(cart) {
    if (window.CartStore && typeof window.CartStore.getApplicableDiscountCodes === 'function') {
      return window.CartStore.getApplicableDiscountCodes(cart).map(normalizeCode).sort();
    }
    return (cart && cart.discount_codes || [])
      .filter(function (entry) { return entry && entry.code && entry.applicable !== false; })
      .map(function (entry) { return normalizeCode(entry.code); })
      .sort();
  }

  function reportedCodes(cart) {
    // Revocation cleanup must also remove the exact own code when Shopify has
    // already marked it inapplicable (for example after removing all goods).
    return (cart && cart.discount_codes || [])
      .filter(function (entry) { return entry && entry.code; })
      .map(function (entry) { return normalizeCode(entry.code); })
      .sort();
  }

  function applicableCodes(cart) {
    var own = manager && manager.nativeAuthorization && normalizeCode(manager.nativeAuthorization.code);
    return enteredCodes(cart).filter(function (code) { return !own || code !== own; });
  }

  function normalizeCode(code) {
    return String(code || '').trim().toLowerCase();
  }

  function managedPackagingVariantIds() {
    if (!window.CartStore ||
        typeof window.CartStore.getManagedPackagingVariantIds !== 'function') return [];
    return window.CartStore.getManagedPackagingVariantIds().map(String);
  }

  function cartFingerprint(cart) {
    var managedPackaging = new Set(managedPackagingVariantIds());
    var lines = (cart && cart.items || []).map(function (item) {
      var properties = item.properties || {};
      var propertyValues = Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; });
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      return [String(item.variant_id || item.id || item.key), Number(item.quantity) || 0,
        Number(item.original_price != null ? item.original_price : item.price) || 0,
        JSON.stringify(propertyValues), String(plan && plan.id || '')].join(':');
    }).filter(function (_line, index) {
      var item = cart.items[index];
      return !managedPackaging.has(String(item.variant_id != null ? item.variant_id : item.id));
    }).sort();
    return JSON.stringify({lines: lines, codes: applicableCodes(cart), currency: cart && cart.currency || ''});
  }

  function promoFingerprint(cart) {
    return JSON.stringify(applicableCodes(cart));
  }

  function cartHasAuthorization(cart) {
    var attributes = cart && cart.attributes || {};
    return Boolean(attributes[BONUS_BINDING_KEY] && attributes[BONUS_REVISION_KEY]);
  }

  function cartBinding(cart) {
    return String(cart && cart.attributes && cart.attributes[BONUS_BINDING_KEY] || '');
  }

  function cartAppliedPoints(cart) {
    var value = Number(cartBinding(cart));
    return Number.isSafeInteger(value) && value > 0 ? value : null;
  }

  function cartRevision(cart) {
    return String(cart && cart.attributes && cart.attributes[BONUS_REVISION_KEY] || '');
  }

  function guestPromoStateClean() {
    return manager.currentCustomerScope() === '0' && manager.sessionCustomerScope === '0' && !manager.firstAuthenticatedWidget() &&
      !manager.legacySessionUnverified && !manager.sessionOwnerMismatch && !manager.unknownOperation &&
      !manager.pendingApply && !manager.pendingRevocation && !manager.pendingLeaseOperation && !manager.pendingRevocationAuthorization &&
      !manager.reservationId && !manager.nativeAuthorization && !manager.authorizationRecovery &&
      !manager.nativeBudgetExpected && !manager.nativeBudgetHead && !manager.nativeBudgetInvalid &&
      !manager.settlementPending && !manager.futureUseRevoked && !manager.checkoutPrepared && !manager.authorizationState;
  }

  function fullGuestPromoCart(cart) {
    return Boolean(cart && typeof cart.token === 'string' && cart.token && Number.isSafeInteger(cart.item_count) && cart.item_count >= 0 &&
      Array.isArray(cart.items) && cart.attributes && typeof cart.attributes === 'object' && !Array.isArray(cart.attributes) &&
      Array.isArray(cart.discount_codes));
  }

  function hasGuestNativeCode(cart) {
    return (cart.discount_codes || []).some(function (entry) { return /^FXB_/i.test(String(entry && entry.code || '').trim()); });
  }

  function guestOrphanMatches(cart, orphan) {
    return Boolean(orphan && fullGuestPromoCart(cart) && cart.token === orphan.cartToken &&
      cartBinding(cart) === orphan.binding && cartRevision(cart) === orphan.cartRevision &&
      !cart.discount_codes.some(function (entry) {
        var code = String(entry && entry.code || '').trim();
        return /^FXB_/i.test(code) && !/^FXB_[A-Za-z0-9_-]{43}$/i.test(code);
      }));
  }

  function summaryUrl(proxyBase, cart, recovery, context) {
    var url = proxyBase + '/summary';
    var binding = cartBinding(cart);
    if ((!cart || !cart.token || !cartHasAuthorization(cart) || !binding) && !recovery && !context) return url;
    var params = new URLSearchParams();
    params.set('cart_token', recovery ? recovery.cartToken : context ? context.cartToken : cart.token);
    if (recovery) {
      params.set('apply_operation_id', recovery.idempotencyKey);
      params.set('cart_revision', recovery.cartRevision);
    } else params.set('authorization_digest', context ? context.authorizationDigest : binding);
    return url + '?' + params.toString();
  }

  function matchesAuthorizationContext(authorization, context, allowLegacy) {
    return Boolean(authorization && context &&
      Number.isSafeInteger(authorization.reservationId) && authorization.reservationId > 0 &&
      authorization.authorizationDigest && (authorization.cartRevision === context.cartRevision ||
        (allowLegacy && authorization.cartRevision === null && authorization.requiresReapply === true)) &&
      (!context.reservationId || authorization.reservationId === context.reservationId) &&
      (!context.authorizationDigest || authorization.authorizationDigest === context.authorizationDigest));
  }

  function confirmedTerminalAuthorization(authorization, context) {
    if (!matchesAuthorizationContext(authorization, context) || authorization.active !== false ||
        !['released', 'expired', 'finalized'].includes(authorization.state) ||
        authorization.projectionPending !== false || authorization.recoveryPending === true ||
        authorization.settlementPending === true) return false;
    if (authorization.authorizationMechanism === 'single_use_code' || context.authorizationMechanism === 'single_use_code') {
      return authorization.authorizationMechanism === 'single_use_code' &&
        authorization.futureUseRevoked === true && authorization.authorizationStatus === 'revoked' &&
        authorization.holdRetained === false && authorization.settlementPending === false;
    }
    return Boolean(context.authorizationDigest || context.applyOperationId);
  }

  function nativeBudgetHead(value) {
    if (!value || !Object.hasOwn(value, 'nativeBudgetProtocol')) return null;
    if (value.nativeBudgetProtocol !== 1 || !Number.isSafeInteger(value.stateVersion) || value.stateVersion < 0 ||
        !Object.hasOwn(value, 'nativeBudget')) throw new Error('bonus_club_native_budget_invalid');
    var budget = value.nativeBudget;
    if (budget !== null) {
      if (!budget || typeof budget !== 'object' || Array.isArray(budget) ||
          !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(budget.id)) ||
          !['unresolved', 'operation_pending', 'consumed_unattributed', 'consumed', 'closed', 'review'].includes(budget.state) ||
          !Number.isSafeInteger(budget.generation) || budget.generation < 1 ||
          (budget.currentReservationId !== null && (!Number.isSafeInteger(budget.currentReservationId) || budget.currentReservationId <= 0)) ||
          typeof budget.canApply !== 'boolean' || (budget.reason !== null && typeof budget.reason !== 'string') ||
          typeof budget.lateSettlementPossible !== 'boolean') throw new Error('bonus_club_native_budget_invalid');
      budget = {id: budget.id, state: budget.state, generation: budget.generation,
        currentReservationId: budget.currentReservationId, canApply: budget.canApply,
        reason: budget.reason, lateSettlementPossible: budget.lateSettlementPossible};
    }
    return {nativeBudgetProtocol: 1, stateVersion: value.stateVersion, nativeBudget: budget};
  }

  function nativeBudgetError() {
    return Object.assign(new Error('bonus_club_native_budget_unconfirmed'), {nativeBudgetUnconfirmed: true});
  }

  function balanceSnapshot(summary) {
    var balance = summary && summary.balance || {};
    return JSON.stringify(['canonicalAvailablePoints', 'canonicalAvailableValueCents', 'debtPoints', 'debtValueCents',
      'availablePoints', 'availableValueCents', 'heldPoints', 'heldValueCents', 'pendingPoints', 'pendingValueCents',
      'redeemedPoints', 'redeemedValueCents', 'expiredPoints', 'expiredValueCents', 'ledgerVersion']
      .map(function (key) { return [key, balance[key]]; }));
  }

  function bonusAllocationCents(cart, title, ownCode) {
    if (!cart || (!title && !ownCode)) return null;
    if (ownCode && (enteredCodes(cart).length !== 1 || enteredCodes(cart)[0] !== normalizeCode(ownCode))) return null;
    var matches = function (application) {
      return ownCode ? application.type === 'discount_code' &&
        (normalizeCode(application.title) === normalizeCode(ownCode) || (title && application.title === title))
        : application.type === 'automatic' && application.title === title;
    };
    var cents = function (value) {
      if ((typeof value !== 'number' && typeof value !== 'string') || String(value).trim() === '') return null;
      var amount = Number(value);
      return Number.isSafeInteger(amount) && amount >= 0 ? amount : null;
    };
    var cartValues = [];
    for (var entry of cart.cart_level_discount_applications || []) {
      if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return null;
      var wrapped = Object.prototype.hasOwnProperty.call(entry, 'discount_application');
      var cartApplication = wrapped ? entry.discount_application : entry;
      if (!cartApplication || typeof cartApplication !== 'object' || Array.isArray(cartApplication)) return null;
      if (wrapped && (['type', 'title', 'total_allocated_amount'].some(function (key) {
        return Object.prototype.hasOwnProperty.call(entry, key);
      }) || Object.prototype.hasOwnProperty.call(cartApplication, 'discount_application'))) return null;
      if (!matches(cartApplication)) continue;
      var cartValue = cents(cartApplication.total_allocated_amount);
      if (cartValue === null || (wrapped && cents(entry.amount) !== cartValue)) return null;
      cartValues.push(cartValue);
    }
    if (cartValues.length > 1) return null;
    var total = 0;
    var seen = false;
    for (var item of cart.items || []) {
      for (var allocation of item.discount_allocations || []) {
        var application = allocation.discount_application || {};
        if (!matches(application)) continue;
        var amount = cents(allocation.amount);
        if (amount === null) return null;
        total += amount;
        seen = true;
      }
    }
    if (seen) return Number.isSafeInteger(total) && (!cartValues.length || cartValues[0] === total) ? total : null;
    return cartValues.length ? cartValues[0] : 0;
  }

  function verifiedCodeProof(value, expected, mode) {
    var proof = value && value.applicationProof;
    if (!value || value.authorizationMechanism !== 'single_use_code' || value.authorizationStatus !== 'projection_acknowledged' ||
        value.futureUseRevoked || value.projectionPending ||
        value.settlementPending || !proof || proof.schemaVersion !== 1 ||
        !/^FXB_[A-Za-z0-9_-]{43}$/.test(String(value.discountCode || '')) ||
        normalizeCode(value.discountCode) !== normalizeCode(proof.code) ||
        value.intentId !== proof.intentId || value.generation !== proof.generation ||
        !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(proof.intentId)) ||
        !Number.isSafeInteger(proof.generation) || proof.generation <= 0 ||
        !Number.isSafeInteger(proof.reservationId) || proof.reservationId <= 0 ||
        !/^[A-Za-z0-9_-]{43}$/.test(String(proof.authorizationDigest)) ||
        !/^[A-Za-z0-9:_-]{16,128}$/.test(String(proof.cartRevision)) ||
        proof.reservationId !== expected.id || proof.authorizationDigest !== expected.digest ||
        proof.cartRevision !== expected.revision || (mode && proof.mode !== mode) ||
        !['cart', 'checkout'].includes(proof.mode) ||
        (proof.mode === 'checkout' ? proof.expiresAt !== null : (!Number.isFinite(Date.parse(proof.expiresAt)) || Date.parse(proof.expiresAt) <= Date.now())) ||
        !/^gid:\/\/shopify\/DiscountCodeNode\/\d+$/.test(String(proof.ownerId)) ||
        !Number.isSafeInteger(proof.publicationSequence) || proof.publicationSequence <= 0 ||
        typeof proof.providerCompareDigest !== 'string' || !proof.providerCompareDigest) return null;
    return proof;
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) { window.setTimeout(resolve, milliseconds); });
  }

  async function observeDiscountEvidence(attributes, cart, observation, options) {
    var recalculations = Math.min(2, Number(observation && observation.maxAdditionalCartRecalculations));
    var retryDelay = Number(observation && observation.retryDelayMilliseconds);
    var updatedCart = cart;
    if (!Number.isSafeInteger(recalculations) || recalculations <= 0 ||
        !Number.isSafeInteger(retryDelay) || retryDelay <= 0) return updatedCart;

    for (var attempt = 0;
      attempt < recalculations && bonusAllocationCents(updatedCart, observation.applicationTitle, options && options.ownCode) === 0;
      attempt += 1) {
      await wait(retryDelay);
      updatedCart = await writeCartAttributes(attributes, options);
    }
    return updatedCart;
  }

  function writeCartAttributes(attributes, options) {
    options = options || {};
    cartAttributeQueue = cartAttributeQueue.catch(function () {}).then(async function () {
      var store = window.CartStore;
      if (store && typeof store.ready === 'function') await store.ready();
      if (store && typeof store.hasPending === 'function' && store.hasPending()) {
        await store.flushNow({urgent: true, throwOnError: true});
      }
      if (options.signal && options.signal.aborted) throw Object.assign(new Error('cancelled'), {name: 'AbortError'});
      if (options.expectedFingerprint && cartFingerprint(authoritativeCart()) !== options.expectedFingerprint) {
        throw new Error('bonus_club_cart_changed_during_apply');
      }
      if (store && typeof store.waitForMutationSlot === 'function') await store.waitForMutationSlot();
      if (options.signal && options.signal.aborted) throw Object.assign(new Error('cancelled'), {name: 'AbortError'});
      var current = authoritativeCart();
      if (options.expectedFingerprint && cartFingerprint(current) !== options.expectedFingerprint) {
        throw new Error('bonus_club_cart_changed_during_apply');
      }
      var expected = options.expectedAuthorization;
      if (expected && (!current || current.token !== expected.cart_token ||
          cartBinding(current) !== expected.authorization_digest ||
          (!expected.legacy_reapply && cartRevision(current) !== expected.cart_revision))) {
        throw new Error('bonus_club_cart_changed_during_removal');
      }

      if (options.expectedCustomerScope) {
        manager.assertSessionMutationAllowed();
        if (manager.currentCustomerScope() !== options.expectedCustomerScope) throw new Error('bonus_club_authorization_unknown');
      }
      if (typeof options.beforeMutation === 'function') options.beforeMutation(current);
      var body = {attributes: attributes};
      if (Object.hasOwn(options, 'discountCode') && options.discountCode !== undefined) body.discount = options.discountCode;
      var updatedCart = await requestJson(cartUpdateUrl(), {
        method: 'POST',
        headers: {'X-Requested-With': 'XMLHttpRequest'},
        body: JSON.stringify(body),
        signal: options.signal,
      });

      if (store && typeof store.reconcileCartResponse === 'function') {
        updatedCart = await store.reconcileCartResponse(updatedCart, {signal: options.signal});
      }
      if (typeof options.verifyResponse === 'function') options.verifyResponse(updatedCart, authoritativeCart());

      if (store && typeof store.acceptServerCart === 'function' &&
          store.acceptServerCart(updatedCart)) {
        return store.getServerCart();
      }
      // A verified combined cleanup must not return an unverified fallback read.
      if (typeof options.verifyResponse === 'function') throw new Error('bonus_club_code_removal_unknown');

      if (store && typeof store.refresh === 'function') {
        await store.refresh();
        var serverCart = store.getServerCart();
        document.dispatchEvent(new CustomEvent('cart:changed', {
          detail: {cart: store.getCart(), serverCart: serverCart, sections: null, flushed: true},
        }));
        return serverCart;
      }
      return requestJson('/cart.js');
    });
    return cartAttributeQueue;
  }

  function technicalId(prefix) {
    var value = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    return prefix + '-' + value.replace(/[^A-Za-z0-9_-]/g, '');
  }

  function copy(widget, key) {
    var property = 'copy' + key.charAt(0).toUpperCase() + key.slice(1);
    return widget.dataset[property] || '';
  }

  function points(value) {
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {useGrouping: true}).format(Number(value) || 0);
  }

  function pointCopy(widget, key, value) {
    return String(copy(widget, key) || '').replace('__POINTS__', points(value));
  }

  function cartBalancePoints(summary) {
    return Number(summary && summary.balance && summary.balance.availablePoints) || 0;
  }


  function cartPointCopy(widget, key, value, summary) {
    var appliedPoints = Number(value) || 0;
    var cartAuthorization = summary && summary.redemption && summary.redemption.cartAuthorization;
    var heldPoints = Number(summary && summary.balance && summary.balance.heldPoints);
    var balanceIncludesReservation = Number.isSafeInteger(heldPoints) && heldPoints >= 0 &&
      cartAuthorization && cartAuthorization.active === true;
    var remainingPoints = cartBalancePoints(summary) - (balanceIncludesReservation ? 0 : appliedPoints);
    return pointCopy(widget, key, appliedPoints)
      .replace('__BALANCE__', points(cartBalancePoints(summary)))
      .replace('__REMAINING__', points(Math.max(0, remainingPoints)));
  }

  function currencyUnit(currencyCode) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(1);
    } catch (_error) {
      return '';
    }
  }

  function currencyAmount(valueCents, currencyCode) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format((Number(valueCents) || 0) / 100);
    } catch (_error) {
      return '';
    }
  }

  function localDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(document.documentElement.lang || undefined).format(date);
  }

  function showToast(message) {
    if (message && window.FrostixCartToast && typeof window.FrostixCartToast.show === 'function') {
      window.FrostixCartToast.show(message);
    }
  }

  function notifyMembershipChanged(action) {
    document.dispatchEvent(new CustomEvent(MEMBERSHIP_CHANGED_EVENT, {
      detail: {action: action},
    }));
  }

  function notifyRedemptionChanged(cart) {
    document.dispatchEvent(new CustomEvent(REDEMPTION_CHANGED_EVENT, {
      detail: {serverCart: cart},
    }));
  }

  async function refreshCartDrawerSection(cart) {
    var store = window.CartStore;
    var patcher = window.frostixCartDrawerPatch;
    if (!store || typeof store.fetchSections !== 'function' ||
        !patcher || typeof patcher.renderSections !== 'function') return false;
    try {
      var sections = await store.fetchSections(['cart-drawer'], window.location.pathname);
      return patcher.renderSections({sections: sections, cart: cart}) === true;
    } catch (_error) {
      return false;
    }
  }

  function savedState() {
    try {
      var scope = manager.currentCustomerScope();
      var key = scope ? SESSION_STATE_KEY + ':customer:' + scope : SESSION_STATE_KEY;
      var raw = sessionStorage.getItem(key);
      if (!raw && key !== SESSION_STATE_KEY) { key = SESSION_STATE_KEY; raw = sessionStorage.getItem(key); }
      var value = JSON.parse(raw || 'null');
      return value && typeof value === 'object' ? {value: value, key: key, raw: raw} : null;
    } catch (_error) {
      return null;
    }
  }

  function saveState(value) {
    try {
      if (manager.legacySessionUnverified) return;
      var scope = manager.currentCustomerScope();
      var key = scope ? SESSION_STATE_KEY + ':customer:' + scope : SESSION_STATE_KEY;
      if (scope === '0') return;
      if (value) sessionStorage.setItem(key, JSON.stringify(Object.assign({}, value, {customerScope: scope})));
      else sessionStorage.removeItem(key);
    } catch (_error) {}
  }

  function markEmailConfirmationPending() {
    try {
      localStorage.setItem(EMAIL_CONFIRMATION_PENDING_KEY, String(Date.now()));
    } catch (_error) {}
  }

  function clearEmailConfirmationPending() {
    try {
      localStorage.removeItem(EMAIL_CONFIRMATION_PENDING_KEY);
    } catch (_error) {}
  }

  function emailConfirmationPendingStartedAt() {
    try {
      var startedAt = Number(localStorage.getItem(EMAIL_CONFIRMATION_PENDING_KEY));
      if (!Number.isSafeInteger(startedAt) || startedAt <= 0 ||
          Date.now() - startedAt > EMAIL_CONFIRMATION_PENDING_MAX_AGE_MILLISECONDS) {
        clearEmailConfirmationPending();
        return 0;
      }
      return startedAt;
    } catch (_error) {
      return 0;
    }
  }

  function hasPendingEmailConfirmation() {
    return emailConfirmationPendingStartedAt() > 0;
  }

  function emailConfirmationResendCooldownRemaining() {
    var startedAt = emailConfirmationPendingStartedAt();
    if (!startedAt) return 0;
    return Math.max(
      0,
      EMAIL_CONFIRMATION_RESEND_COOLDOWN_MILLISECONDS - (Date.now() - startedAt),
    );
  }

  function emailConfirmationPending(summary) {
    var eligibilityReason = summary && summary.membership &&
      summary.membership.eligibility && summary.membership.eligibility.reason;
    return Boolean(
      summary && summary.ok && summary.customer &&
      summary.customer.status === 'not_enrolled' &&
      ['newsletter_unconfirmed', 'email_unverified'].includes(eligibilityReason)
    );
  }

  function customerStateSignature(summary) {
    if (!summary || !summary.ok || !summary.customer) return '';
    var eligibility = summary.membership && summary.membership.eligibility || {};
    var balance = summary.balance || {};
    var authorization = summary.redemption && summary.redemption.authorization || {};
    return JSON.stringify({
      status: summary.customer.status || '',
      eligibilityReason: eligibility.reason || '',
      availablePoints: Number(balance.availablePoints) || 0,
      authorizationAllowed: authorization.allowed === true,
      authorizationReason: authorization.reason || '',
    });
  }

  var manager = {
    whenReadyForCartActions: function () { return cartActionsReady; },
    fingerprint: cartFingerprint,
    readTiming: readTiming,
    readRequestTiming: readRequestTiming,
    initialPreviewRequest: initialPreviewRequest,
    declineInitialPreview: function (source) {
      if (!cartInitialEnabled() || !source || !source.dataset ||
          !(source.dataset.surface === 'cart' || source.evidence && source.evidence.surface === 'cart') ||
          String(source.dataset.customerScope) !== this.currentCustomerScope() ||
          String(source.dataset.proxyBase || '').replace(/\/$/, '') !== this.proxyBase()) return;
      declineInitialCart(initialCartGate());
    },
    widgets: new Set(),
    summary: null,
    summaryPromise: null,
    summaryRequestRevision: 0,
    summaryReadFailureRevision: 0,
    initialized: false,
    operation: null,
    financialPromise: null,
    financialController: null,
    reservationId: null,
    authorizationState: null,
    checkoutPrepared: false,
    checkoutReturnedByNavigation: false,
    checkoutReturnNavigationHandled: false,
    applicationTitle: null,
    appliedValueCents: null,
    pendingApply: null,
    pendingRevocation: null,
    nativeAuthorization: null,
    nativeBudgetExpected: false,
    nativeBudgetCustomerScope: null,
    nativeBudgetHead: null,
    nativeBudgetInvalid: false,
    summaryStateVersion: null,
    summaryAcceptedRevision: 0,
    pendingRevocationAuthorization: null,
    pendingLeaseOperation: null,
    authorizationRecovery: null,
    settlementPending: false,
    futureUseRevoked: false,
    unknownOperation: false,
    sessionCustomerScope: null,
    sessionOwnerMismatch: false,
    legacySessionUnverified: false,
    legacySessionStorage: null,
    legacySessionContext: null,
    legacySessionUsesCurrentCart: false,
    guestCartOrphan: null,
    summaryLoadedAt: 0,
    summaryCartBinding: '',
    lastActivityAt: 0,
    lastActivityRenewedAt: 0,
    crossTabChannel: null,
    applied: false,
    appliedPoints: null,
    redemptionPreviewPoints: null,
    redemptionPreviewReason: null,
    redemptionNoticeReason: null,
    guestOffer: null,
    earningPreviewFailed: false,
    emailConfirmationSent: false,
    binding: '',
    baseline: null,
    baselinePromo: null,
    lastObservedFingerprint: null,
    leaseTimer: null,
    leaseRefreshAfterSeconds: null,
    unregisterCheckoutTask: null,
    customerStatusPollTimer: null,
    customerStatusWatchUntil: 0,
    customerStatusRefreshPromise: null,
    activityCartChangePending: false,
    emailConfirmationResendTimer: null,
    enrollmentIntentAttempt: null,

    register: function (widget) {
      this.widgets.add(widget);
      this.renderWidget(widget);
      if (!this.initialized) this.initialize();
      else {
        if (widget.dataset.context === 'account') this.loadHistory(widget);
        this.recordEnrollmentIntent(this.summary, this.firstEnrollmentWidget());
      }
    },

    unregister: function (widget) {
      this.widgets.delete(widget);
      if (this.widgets.size === 0) this.stopCartLease();
    },

    runFinancial: function (name, action) {
      if (!this.financialPromise) {
        this.operation = name;
        this.renderAll();
      }
      var previous = this.financialPromise || Promise.resolve();
      var task = previous.catch(function () {}).then(async function () {
        manager.operation = name;
        manager.renderAll();
        var controller = new AbortController();
        manager.financialController = controller;
        var timer;
        var deadline = new Promise(function (_resolve, reject) {
          timer = setTimeout(function () {
            if (manager.reservationId || manager.pendingApply) manager.markUnknown();
            controller.abort();
            reject(Object.assign(new Error('bonus_club_operation_timeout'), {name: 'TimeoutError'}));
          }, FINANCIAL_BARRIER_MILLISECONDS);
        });
        try {
          var guardedAction = async function () {
            if (manager.legacySessionUnverified) await manager.refreshSummary(null, {preserveCurrent: true});
            if (manager.currentCustomerScope() === '0' && name === 'checkout' && !manager.legacySessionUnverified &&
                !manager.unknownOperation && !manager.nativeAuthorization && !cartHasAuthorization(authoritativeCart())) return;
            if (name === 'promo') manager.assertPromoMutationAllowed(authoritativeCart());
            else manager.assertSessionMutationAllowed();
            return action(controller.signal);
          };
          if (window.navigator && window.navigator.locks && typeof window.navigator.locks.request === 'function') {
            return await Promise.race([deadline, window.navigator.locks.request('frostix-bonus-club-financial-v1', {signal: controller.signal}, function () {
              return guardedAction();
            })]);
          }
          return await Promise.race([deadline, guardedAction()]);
        } finally {
          clearTimeout(timer);
          if (manager.financialController === controller) manager.financialController = null;
          manager.operation = null;
          manager.renderAll();
        }
      });
      this.financialPromise = task;
      task.finally(function () {
        if (manager.financialPromise === task) manager.financialPromise = null;
      }).catch(function () {});
      return task;
    },

    broadcastChange: function () {
      if (this.crossTabChannel) this.crossTabChannel.postMessage({type: 'invalidate'});
    },

    initialize: async function () {
      this.initialized = true;
      this.onCustomerStatusResume = this.onCustomerStatusResume.bind(this);
      document.addEventListener('cart:changed', this.onCartChanged.bind(this));
      document.addEventListener('visibilitychange', this.onCustomerStatusResume);
      window.addEventListener('pageshow', this.onCustomerStatusResume);
      window.addEventListener('focus', this.onCustomerStatusResume);
      document.addEventListener('frostix:cart-activity', this.onCartActivity.bind(this));
      if (typeof window.BroadcastChannel === 'function') {
        this.crossTabChannel = new window.BroadcastChannel('frostix-bonus-club-invalidation-v1');
        this.crossTabChannel.onmessage = function () {
          manager.summaryLoadedAt = 0;
          manager.onCustomerStatusResume();
        };
      }
      document.addEventListener(
        'frostix:bonus-club-earning-preview',
        this.onEarningPreview.bind(this)
      );
      if (window.FrostixBonusClubEarningPreviewState) {
        this.onEarningPreview({detail: window.FrostixBonusClubEarningPreviewState});
      }
      if (window.CartStore && typeof window.CartStore.ready === 'function') await window.CartStore.ready();
      readTiming('cart_ready');
      var cart = authoritativeCart();
      this.lastObservedFingerprint = cart ? cartFingerprint(cart) : null;
      this.applied = cartHasAuthorization(cart);
      this.binding = cartBinding(cart);
      this.sessionCustomerScope = this.currentCustomerScope();
      var scope = this.sessionCustomerScope;
      var stored = savedState();
      var previous = stored && stored.value;
      var previousScope = previous && typeof previous.customerScope === 'string' && /^(0|[1-9]\d*)$/.test(previous.customerScope) ? previous.customerScope : null;
      if (previous && ((previousScope && scope && previousScope !== scope) ||
          (previous.nativeBudgetExpected && previous.nativeBudgetCustomerScope && scope && previous.nativeBudgetCustomerScope !== scope))) previous = null;
      else if (previous && (!previousScope || !this.sessionCustomerScope)) {
        this.legacySessionUnverified = true;
        this.legacySessionStorage = stored;
        var oldLease = previous.pendingLeaseOperation && previous.pendingLeaseOperation.body;
        var oldProof = previous.nativeAuthorization && previous.nativeAuthorization.proof;
        var oldBinding = previous.binding || previous.pendingRevocation && previous.pendingRevocation.authorization_digest ||
          oldLease && oldLease.authorization_digest || previous.authorizationRecovery && previous.authorizationRecovery.authorizationDigest || oldProof && oldProof.authorizationDigest;
        var oldToken = previous.pendingApply && previous.pendingApply.cartToken || previous.pendingRevocation && previous.pendingRevocation.cart_token ||
          oldLease && oldLease.cart_token || previous.authorizationRecovery && previous.authorizationRecovery.cartToken;
        var oldRevision = previous.pendingApply && previous.pendingApply.cartRevision || previous.pendingRevocation && previous.pendingRevocation.cart_revision ||
          oldLease && oldLease.cart_revision || previous.authorizationRecovery && previous.authorizationRecovery.cartRevision || oldProof && oldProof.cartRevision;
        this.legacySessionUsesCurrentCart = Boolean(cartHasAuthorization(cart) &&
          ((!oldBinding && !oldToken && !oldRevision) || (oldBinding && oldBinding !== cartBinding(cart)) ||
            (oldToken && oldToken !== cart.token) || (oldRevision && oldRevision !== cartRevision(cart))));
        if (this.legacySessionUsesCurrentCart) previous = null;
      }
      this.nativeAuthorization = previous && previous.nativeAuthorization || null;
      this.lastObservedFingerprint = cart ? cartFingerprint(cart) : null;
      this.pendingLeaseOperation = previous && previous.pendingLeaseOperation || null;
      this.settlementPending = Boolean(previous && previous.settlementPending);
      this.futureUseRevoked = Boolean(previous && previous.futureUseRevoked);
      this.pendingApply = previous && previous.pendingApply || null;
      this.pendingRevocation = previous && previous.pendingRevocation || null;
      this.authorizationRecovery = previous && previous.authorizationRecovery || null;
      this.nativeBudgetExpected = Boolean(previous && previous.nativeBudgetExpected);
      this.nativeBudgetCustomerScope = previous && previous.nativeBudgetCustomerScope || scope || null;
      this.nativeBudgetInvalid = Boolean(previous && previous.nativeBudgetInvalid);
      this.pendingRevocationAuthorization = previous && previous.pendingRevocationAuthorization || null;
      if (previous && previous.nativeBudgetHead) this.acceptNativeBudgetHead(previous.nativeBudgetHead);
      this.applicationTitle = previous && previous.applicationTitle || null;
      this.appliedValueCents = previous && previous.appliedValueCents || null;
      this.reservationId = previous && Number.isSafeInteger(previous.reservationId) ? previous.reservationId : null;
      if (!this.binding && previous) this.binding = previous.binding || '';
      this.unknownOperation = Boolean(this.legacySessionUnverified || previous && previous.unknownOperation || this.pendingApply || this.pendingRevocation || this.pendingLeaseOperation || this.settlementPending || this.nativeBudgetInvalid);
      this.authorizationState = previous && previous.authorizationState || null;
      this.checkoutPrepared = Boolean(previous && previous.checkoutPrepared);
      if (this.legacySessionUnverified) this.legacySessionContext = this.summaryAuthorizationContext(cart);
      if (this.checkoutPrepared && document.referrer) {
        try { this.checkoutReturnedByNavigation = /\/checkouts?\//.test(new URL(document.referrer).pathname); } catch (_error) {}
      }
      if (this.applied && previous && previous.binding === this.binding) {
        this.baseline = previous.fingerprint;
        this.baselinePromo = previous.promoFingerprint;
        this.appliedPoints = Number.isSafeInteger(previous.appliedPoints) && previous.appliedPoints > 0
          ? previous.appliedPoints
          : null;
      } else if (this.applied) {
        this.baseline = cartFingerprint(cart);
        this.baselinePromo = promoFingerprint(cart);
        this.persistAppliedState();
      }

      // Capture only cart-derived guest markers. Owner receipts and recovery state
      // remain under the authenticated session's financial guards.
      if (guestPromoStateClean() && this.applied && fullGuestPromoCart(cart) &&
          this.binding === cartBinding(cart) && /^[A-Za-z0-9_-]{43}$/.test(cartBinding(cart)) &&
          /^[A-Za-z0-9:_-]{16,128}$/.test(cartRevision(cart))) {
        var guestOrphan = {cartToken: cart.token, binding: cartBinding(cart), cartRevision: cartRevision(cart)};
        if (guestOrphanMatches(cart, guestOrphan)) this.guestCartOrphan = guestOrphan;
      }

      initialCartContextReady = true;
      if (initialCartRead && !cleanInitialCart(cart, this.sessionCustomerScope)) declineInitialCart(initialCartRead);

      if (window.CartStore && typeof window.CartStore.registerBeforeCheckoutTask === 'function') {
        this.unregisterCheckoutTask = window.CartStore.registerBeforeCheckoutTask(function (serverCart) {
          return manager.prepareCheckout(serverCart);
        });
        resolveCartActionsReady();
      }
      var checkoutReturnHint = this.takeCheckoutReturnHint(cart);
      if (checkoutReturnHint) {
        this.checkoutReturnNavigationHandled = true;
        this.renderAll();
        await this.loadSummary({initialCart: true});
        this.syncEmailConfirmationStatus();
        await this.reconcileCheckoutReturn(checkoutReturnHint);
        return;
      }
      if (this.applied && previous && previous.binding === this.binding &&
          cartFingerprint(cart) !== this.baseline) {
        var widget = this.firstAuthenticatedWidget();
        if (widget) {
          var reason = promoFingerprint(cart) === this.baselinePromo ? 'cartChanged' : 'promoChanged';
          await this.remove(widget, reason);
          return;
        }
      }
      this.renderAll();
      await this.loadSummary({initialCart: true});
      this.syncEmailConfirmationStatus();
      if (window.location && /\/cart\/?$/.test(window.location.pathname)) {
        this.onCartActivity({detail: {activity: 'cart_opened'}});
      }
    },

    checkoutReturnContextMatches: function (hint, cart) {
      var proof = this.nativeAuthorization && this.nativeAuthorization.proof;
      var recovery = this.authorizationRecovery;
      return Boolean(hint && Date.now() - hint.createdAt >= 0 &&
        Date.now() - hint.createdAt <= CHECKOUT_RETURN_HINT_MAX_AGE_MILLISECONDS &&
        cart && cart.token === hint.cartToken && Array.isArray(cart.items) &&
        Array.isArray(cart.discount_codes) && cart.attributes &&
        this.currentCustomerScope() === hint.customerScope && this.sessionCustomerScope === hint.customerScope &&
        this.checkoutPrepared === true && this.authorizationState === 'checkout_pending' &&
        !this.legacySessionUnverified && !this.sessionOwnerMismatch && !this.nativeBudgetInvalid &&
        !this.settlementPending && !this.futureUseRevoked && !this.pendingApply && !this.pendingRevocation && !this.pendingLeaseOperation &&
        this.reservationId === hint.reservationId && this.binding === hint.authorizationDigest &&
        recovery && recovery.cartToken === hint.cartToken && recovery.reservationId === hint.reservationId &&
        recovery.authorizationDigest === hint.authorizationDigest && recovery.cartRevision === hint.cartRevision &&
        proof && proof.mode === 'checkout' && proof.expiresAt === null && proof.reservationId === hint.reservationId &&
        proof.authorizationDigest === hint.authorizationDigest && proof.cartRevision === hint.cartRevision &&
        proof.intentId === hint.intentId && proof.generation === hint.generation &&
        ((!cartBinding(cart) && !cartRevision(cart)) ||
          (cartBinding(cart) === hint.authorizationDigest && cartRevision(cart) === hint.cartRevision)));
    },

    takeCheckoutReturnHint: function (cart) {
      try {
        if (window.location.hostname === 'frostix-loyalty-dev.myshopify.com') {
          var diagnostic = sessionStorage.getItem(CHECKOUT_RETURN_DIAGNOSTIC_KEY);
          sessionStorage.removeItem(CHECKOUT_RETURN_DIAGNOSTIC_KEY);
          if (diagnostic && diagnostic.length <= 4_096) {
            try {
              var redirect = JSON.parse(diagnostic);
              if (['redirect_created', 'redirect_declined', 'redirect_error', 'redirect_unavailable'].includes(redirect.stage)) checkoutReturnDiagnostic(redirect.stage, redirect);
            } catch (_diagnosticError) { checkoutReturnDiagnostic('redirect_diagnostic_invalid'); }
          }
        }
        var raw = sessionStorage.getItem(CHECKOUT_RETURN_HINT_KEY);
        if (!raw) { checkoutReturnDiagnostic('hint_missing'); return null; }
        if (raw.length > 4_096) { sessionStorage.removeItem(CHECKOUT_RETURN_HINT_KEY); checkoutReturnDiagnostic('hint_oversized'); return null; }
        var hint = JSON.parse(raw);
        if (hint && checkoutReturnRootPath(hint.rootPath) !== null &&
            checkoutReturnRootPath(window.location.pathname) !== checkoutReturnRootPath(hint.rootPath)) {
          checkoutReturnDiagnostic('hint_non_destination'); return null;
        }
        sessionStorage.removeItem(CHECKOUT_RETURN_HINT_KEY);
        var referrer = new URL(document.referrer);
        var age = Date.now() - hint.createdAt;
        if (!hint || hint.schemaVersion !== 1 || !Number.isSafeInteger(hint.createdAt) ||
            age < 0 || age > CHECKOUT_RETURN_HINT_MAX_AGE_MILLISECONDS ||
            !/^[1-9]\d*$/.test(String(hint.customerScope)) || typeof hint.customerScope !== 'string' ||
            !Number.isSafeInteger(hint.reservationId) || hint.reservationId <= 0 ||
            !/^[A-Za-z0-9_-]{43}$/.test(String(hint.authorizationDigest)) ||
            !/^[A-Za-z0-9:_-]{16,128}$/.test(String(hint.cartRevision)) ||
            typeof hint.cartToken !== 'string' || !hint.cartToken ||
            !Number.isSafeInteger(hint.generation) || hint.generation <= 0 ||
            typeof hint.intentId !== 'string' || !hint.intentId) {
          checkoutReturnDiagnostic('hint_shape_declined', {schemaValid: Boolean(hint && hint.schemaVersion === 1),
            ageValid: Boolean(hint && Number.isSafeInteger(hint.createdAt) && age >= 0 && age <= CHECKOUT_RETURN_HINT_MAX_AGE_MILLISECONDS),
            scopeValid: Boolean(hint && typeof hint.customerScope === 'string' && /^[1-9]\d*$/.test(hint.customerScope)),
            approvalValid: Boolean(hint && Number.isSafeInteger(hint.reservationId) && hint.reservationId > 0),
            bindingValid: Boolean(hint && /^[A-Za-z0-9_-]{43}$/.test(String(hint.authorizationDigest))),
            revisionValid: Boolean(hint && /^[A-Za-z0-9:_-]{16,128}$/.test(String(hint.cartRevision))),
            tokenValid: Boolean(hint && typeof hint.cartToken === 'string' && hint.cartToken),
            generationValid: Boolean(hint && Number.isSafeInteger(hint.generation) && hint.generation > 0),
            intentValid: Boolean(hint && typeof hint.intentId === 'string' && hint.intentId)}); return null;
        }
        var navigationChecks = {sameOrigin: referrer.origin === window.location.origin,
          referrerMatches: referrer.pathname === hint.cartPath, cartPathValid: /\/cart\/?$/.test(hint.cartPath),
          rootMatches: window.location.pathname === hint.rootPath,
          rootCanonicalMatches: checkoutReturnRootPath(window.location.pathname) !== null &&
            checkoutReturnRootPath(window.location.pathname) === checkoutReturnRootPath(hint.rootPath)};
        if (!navigationChecks.sameOrigin || !navigationChecks.referrerMatches || !navigationChecks.cartPathValid || !navigationChecks.rootCanonicalMatches) {
          checkoutReturnDiagnostic('hint_navigation_declined', navigationChecks); return null;
        }
        if (!this.checkoutReturnContextMatches(hint, cart)) {
          var proof = this.nativeAuthorization && this.nativeAuthorization.proof;
          var recovery = this.authorizationRecovery;
          checkoutReturnDiagnostic('hint_context_declined', {cartMatches: Boolean(cart && cart.token === hint.cartToken),
            cartShapeValid: Boolean(cart && Array.isArray(cart.items) && Array.isArray(cart.discount_codes) && cart.attributes),
            approvalMatches: this.reservationId === hint.reservationId && this.binding === hint.authorizationDigest,
            markersMatch: Boolean(cart && ((!cartBinding(cart) && !cartRevision(cart)) ||
              (cartBinding(cart) === hint.authorizationDigest && cartRevision(cart) === hint.cartRevision))),
            scopeMatches: this.currentCustomerScope() === hint.customerScope && this.sessionCustomerScope === hint.customerScope,
            prepared: this.checkoutPrepared === true, checkoutState: this.authorizationState === 'checkout_pending',
            pendingClear: !this.pendingApply && !this.pendingRevocation && !this.pendingLeaseOperation,
            settlementClear: !this.settlementPending && !this.futureUseRevoked,
            budgetValid: !this.legacySessionUnverified && !this.sessionOwnerMismatch && !this.nativeBudgetInvalid,
            recoveryMatches: Boolean(recovery && recovery.cartToken === hint.cartToken && recovery.reservationId === hint.reservationId &&
              recovery.authorizationDigest === hint.authorizationDigest && recovery.cartRevision === hint.cartRevision),
            proofMatches: Boolean(proof && proof.mode === 'checkout' && proof.expiresAt === null && proof.reservationId === hint.reservationId &&
              proof.authorizationDigest === hint.authorizationDigest && proof.cartRevision === hint.cartRevision &&
              proof.intentId === hint.intentId && proof.generation === hint.generation)});
          return null;
        }
        checkoutReturnDiagnostic('hint_accepted', navigationChecks);
        return hint;
      } catch (_error) {
        try { sessionStorage.removeItem(CHECKOUT_RETURN_HINT_KEY); } catch (_storageError) {}
        checkoutReturnDiagnostic('hint_error'); return null;
      }
    },

    reconcileCheckoutReturn: async function (hint) {
      var cart = authoritativeCart();
      var summary = this.summary;
      var authorization = summary && summary.redemption && summary.redemption.cartAuthorization;
      var proof = verifiedCodeProof(authorization, {id: hint.reservationId, digest: hint.authorizationDigest,
        revision: hint.cartRevision}, 'checkout');
      var owner = summary && summary.customer;
      if (!summary || summary.ok !== true || !owner || owner.authenticated !== true ||
          owner.id !== 'gid://shopify/Customer/' + hint.customerScope || this.summaryAcceptedRevision <= 0 ||
          this.summaryReadFailureRevision !== 0 || !proof || authorization.active !== true ||
          authorization.requiresReapply === true || authorization.state !== 'checkout_pending' ||
          !this.checkoutReturnContextMatches(hint, cart)) {
        checkoutReturnDiagnostic('summary_declined', {summaryOk: Boolean(summary && summary.ok === true),
          ownerMatches: Boolean(owner && owner.authenticated === true && owner.id === 'gid://shopify/Customer/' + hint.customerScope),
          summaryFresh: this.summaryAcceptedRevision > 0 && this.summaryReadFailureRevision === 0,
          proofValid: Boolean(proof), authorizationActive: Boolean(authorization && authorization.active === true && authorization.requiresReapply !== true),
          authorizationCheckout: Boolean(authorization && authorization.state === 'checkout_pending'),
          contextMatches: this.checkoutReturnContextMatches(hint, cart)});
        return false;
      }
      var fingerprint = cartFingerprint(cart);
      var assertCurrent = function () {
        manager.assertSessionMutationAllowed();
        var current = authoritativeCart();
        var budget = manager.nativeBudgetHead && manager.nativeBudgetHead.nativeBudget;
        if (!manager.checkoutReturnContextMatches(hint, current) || cartFingerprint(current) !== fingerprint ||
            (manager.nativeBudgetExpected && (!budget || budget.state !== 'unresolved' ||
              budget.currentReservationId !== hint.reservationId || budget.generation !== hint.generation))) {
          throw new Error('bonus_club_checkout_state_unknown');
        }
      };
      try { assertCurrent(); } catch (_error) { checkoutReturnDiagnostic('current_fence_declined'); return false; }
      if (applicableCodes(cart).length && !hasGuestNativeCode(cart)) {
        checkoutReturnDiagnostic('promo_remove_started');
        await this.remove(this.firstAuthenticatedWidget(), 'promoChanged', {beforeMutation: assertCurrent});
        checkoutReturnDiagnostic('promo_remove_finished', {pendingClear: !this.pendingRevocation, unknownClear: !this.unknownOperation});
        return true;
      }
      if (!cartHasAuthorization(cart) || !this.applied || this.unknownOperation || fingerprint !== this.baseline ||
          bonusAllocationCents(cart, this.applicationTitle, this.nativeAuthorization.code) !== this.appliedValueCents) {
        checkoutReturnDiagnostic('native_declined', {cartAuthorized: cartHasAuthorization(cart), applied: this.applied,
          unknownClear: !this.unknownOperation, fingerprintMatches: fingerprint === this.baseline,
          allocationMatches: bonusAllocationCents(cart, this.applicationTitle, this.nativeAuthorization.code) === this.appliedValueCents});
        return false;
      }
      this.checkoutReturnedByNavigation = true;
      checkoutReturnDiagnostic('native_return_started');
      await this.onCartActivity({detail: {activity: 'cart_opened'}}, {beforeMutation: assertCurrent});
      checkoutReturnDiagnostic('native_return_finished', {prepared: this.checkoutPrepared, unknownClear: !this.unknownOperation, pendingClear: !this.pendingLeaseOperation});
      return true;
    },

    firstAuthenticatedWidget: function () {
      return Array.from(this.widgets).find(function (widget) {
        return widget.dataset.authenticated === 'true';
      });
    },

    enrollmentWidgetVisible: function (widget) {
      if (!widget || widget.dataset.authenticated !== 'true' || widget.hidden === true) return false;
      if (typeof widget.closest !== 'function') return false;
      if (widget.closest('[hidden], [aria-hidden="true"]')) return false;
      if (widget.dataset.context === 'account' || widget.dataset.context === 'after_purchase') return true;
      if (widget.dataset.context !== 'cart') return false;
      var drawer = widget.closest('cart-drawer');
      return Boolean(drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open')));
    },

    firstEnrollmentWidget: function () {
      var visible = Array.from(this.widgets).filter(function (widget) { return manager.enrollmentWidgetVisible(widget); });
      return visible.find(function (widget) { return widget.dataset.context === 'account'; }) || visible[0];
    },

    enrollmentIntentRequired: function (summary, widget) {
      var scope = widget && String(widget.dataset.customerScope || '');
      return Boolean(widget && widget.dataset.authenticated === 'true' &&
        ['cart', 'account', 'after_purchase'].includes(widget.dataset.context) &&
        /^[1-9]\d*$/.test(scope) && scope === this.currentCustomerScope() &&
        scope === this.sessionCustomerScope && !this.sessionOwnerMismatch &&
        summary && summary.ok === true && summary.customer && summary.customer.authenticated === true &&
        summary.customer.id === 'gid://shopify/Customer/' + scope &&
        summary.customer.status === 'not_enrolled' &&
        summary.membership && summary.membership.enrollmentIntentRequired === true &&
        !(summary.maintenance && summary.maintenance.enabled));
    },

    enrollmentIntentSource: function (widget) {
      var accountPresent = Array.from(this.widgets).some(function (entry) {
        return entry.dataset.context === 'account' && manager.enrollmentWidgetVisible(entry);
      });
      var source = accountPresent ? 'account' : widget.dataset.context;
      try {
        var saved = JSON.parse(sessionStorage.getItem(ENROLLMENT_SOURCE_KEY));
        var age = saved && Date.now() - saved.createdAt;
        if (saved && saved.source === 'cart' && age >= 0 && age <= ENROLLMENT_SOURCE_MAX_AGE_MILLISECONDS) return 'cart';
        sessionStorage.removeItem(ENROLLMENT_SOURCE_KEY);
      } catch (_error) {}
      return source;
    },

    recordEnrollmentIntent: function (summary, widget, retry) {
      if (!this.enrollmentIntentRequired(summary, widget) || !this.enrollmentWidgetVisible(widget)) return Promise.resolve(summary);
      var scope = this.currentCustomerScope();
      var proxyBase = this.proxyBase();
      var attempt = this.enrollmentIntentAttempt;
      if (attempt && attempt.scope === scope && attempt.proxyBase === proxyBase) {
        // A stale summary or a second widget must never start a second mutation.
        // Only the visible retry action can repeat a failed request, with the same key.
        if (!retry || !attempt.failed || attempt.pending) return Promise.resolve(summary);
      } else {
        attempt = {scope: scope, proxyBase: proxyBase, source: this.enrollmentIntentSource(widget),
          idempotencyKey: technicalId('membership-intent')};
        this.enrollmentIntentAttempt = attempt;
      }
      attempt.failed = false;
      attempt.pending = true;
      this.renderAll();
      attempt.promise = requestJson(proxyBase + '/enrollment-intent', {
        method: 'POST',
        body: JSON.stringify({source: attempt.source, idempotency_key: attempt.idempotencyKey}),
      }).then(function (result) {
        if (!result || result.ok !== true) throw new Error('bonus_club_enrollment_intent_unconfirmed');
        if (manager.currentCustomerScope() !== scope || manager.sessionCustomerScope !== scope ||
            manager.proxyBase() !== proxyBase) return manager.summary;
        try { sessionStorage.removeItem(ENROLLMENT_SOURCE_KEY); } catch (_error) {}
        return manager.refreshSummary(null, {preserveCurrent: true}).then(function (updated) {
          if (manager.enrollmentIntentRequired(updated, widget)) throw new Error('bonus_club_enrollment_intent_unconfirmed');
          return updated;
        });
      }).catch(function () {
        attempt.failed = true;
        return manager.summary;
      }).finally(function () {
        attempt.pending = false;
        manager.renderAll();
      });
      return attempt.promise;
    },

    currentCustomerScope: function () {
      var scopes = Array.from(this.widgets).map(function (widget) { return widget.dataset.customerScope; })
        .filter(function (value) { return /^(0|[1-9]\d*)$/.test(String(value || '')); });
      return scopes.length && scopes.every(function (value) { return value === scopes[0]; }) ? scopes[0] : null;
    },

    assertSessionMutationAllowed: function () {
      var scope = this.currentCustomerScope();
      if (scope === '0' || this.legacySessionUnverified || this.sessionOwnerMismatch ||
          (this.sessionCustomerScope && scope !== this.sessionCustomerScope)) throw new Error('bonus_club_authorization_unknown');
    },

    assertPromoMutationAllowed: function (cart) {
      if (this.currentCustomerScope() !== '0') return this.assertSessionMutationAllowed();
      var orphan = this.guestCartOrphan;
      var matchingOrphan = orphan && guestOrphanMatches(cart, orphan) && this.applied === true && this.binding === orphan.binding;
      if (!guestPromoStateClean() || !fullGuestPromoCart(cart) || (orphan && !matchingOrphan) ||
          (!matchingOrphan && (this.applied || this.binding || cartBinding(cart) || cartRevision(cart) || hasGuestNativeCode(cart)))) {
        throw new Error('bonus_club_authorization_unknown');
      }
    },

    preparePromoCartMutation: function (cart, code) {
      this.assertPromoMutationAllowed(cart);
      if (this.currentCustomerScope() !== '0') return null;
      if (String(code || '').split(',').some(function (entry) { return /^FXB_/i.test(entry.trim()); })) {
        throw new Error('bonus_club_authorization_unknown');
      }
      var context = {cartToken: cart.token, orphan: this.guestCartOrphan};
      if (context.orphan) {
        context.attributes = {};
        context.attributes[BONUS_BINDING_KEY] = null;
        context.attributes[BONUS_REVISION_KEY] = null;
      }
      return context;
    },

    assertGuestPromoCartContext: function (cart, context) {
      if (!guestPromoStateClean() || !context || context.orphan !== this.guestCartOrphan ||
          !cart || cart.token !== context.cartToken) throw new Error('bonus_club_authorization_unknown');
      this.assertPromoMutationAllowed(cart);
    },

    assertGuestPromoCartResponse: function (cart, context, previousCart) {
      this.assertGuestPromoCartContext(previousCart, context);
      if (!fullGuestPromoCart(cart) || cart.token !== context.cartToken || cartBinding(cart) || cartRevision(cart) || hasGuestNativeCode(cart)) {
        throw new Error('bonus_club_authorization_unknown');
      }
    },

    confirmGuestPromoCartResponse: function (context) {
      // This runs synchronously after the verified response is adopted, including
      // an ordinary coupon's 422 result. Preserve every stored owner receipt.
      if (context.orphan) {
        this.applied = false;
        this.binding = '';
        this.guestCartOrphan = null;
      }
    },

    reconcileLegacySessionOwner: function (summary, cart, context) {
      if (!this.legacySessionUnverified) return;
      var scope = this.currentCustomerScope();
      var customer = summary && summary.customer;
      var owner = customer && /^gid:\/\/shopify\/Customer\/([1-9]\d*)$/.exec(String(customer.id || ''));
      var authorization = summary && summary.redemption && summary.redemption.cartAuthorization;
      var legacyNullRevision = context && authorization && context.cartRevision === null && authorization.cartRevision === null &&
        authorization.requiresReapply === true && context.authorizationDigest && Number.isSafeInteger(context.reservationId);
      if (!scope || scope === '0' || !summary.ok || !customer || customer.authenticated !== true || !owner || owner[1] !== scope ||
          !context || !context.cartToken || (!context.cartRevision && !legacyNullRevision) ||
          JSON.stringify(context) !== JSON.stringify(this.legacySessionContext) ||
          !matchesAuthorizationContext(authorization, context) || authorization.recoveryPending === true ||
          !['reserved', 'checkout_pending', 'revocation_pending', 'released', 'expired', 'finalized'].includes(authorization.state)) return;
      var originalApply = this.legacySessionStorage && this.legacySessionStorage.value.pendingApply;
      if (!this.legacySessionUsesCurrentCart && originalApply && originalApply.requestBody &&
          (originalApply.requestBody.cart_token !== context.cartToken || originalApply.requestBody.cart_revision !== context.cartRevision ||
            originalApply.requestBody.idempotency_key !== context.applyOperationId)) return;
      if (this.legacySessionUsesCurrentCart) {
        var proof = authorization.authorizationMechanism === 'single_use_code'
          ? verifiedCodeProof(authorization, {id: authorization.reservationId, digest: authorization.authorizationDigest,
            revision: authorization.cartRevision}) : null;
        if (!cart || cart.token !== context.cartToken || cartBinding(cart) !== authorization.authorizationDigest ||
            cartRevision(cart) !== authorization.cartRevision || authorization.active !== true ||
            (authorization.authorizationMechanism === 'single_use_code' && !proof) ||
            bonusAllocationCents(cart, authorization.applicationTitle, proof && proof.code) !== authorization.valueCents ||
            (cart.currency && cart.currency !== authorization.currencyCode)) return;
      } else {
        var stored = this.legacySessionStorage;
        try {
          var migratedKey = SESSION_STATE_KEY + ':customer:' + scope;
          var migrated = JSON.stringify(Object.assign({}, stored.value, {customerScope: scope}));
          sessionStorage.setItem(migratedKey, migrated);
          if (stored.key !== migratedKey && sessionStorage.getItem(migratedKey) === migrated &&
              sessionStorage.getItem(stored.key) === stored.raw) sessionStorage.removeItem(stored.key);
        } catch (_error) {}
      }
      this.legacySessionUnverified = false;
      this.legacySessionStorage = null;
      this.legacySessionContext = null;
      if (this.legacySessionUsesCurrentCart) this.unknownOperation = false;
      this.legacySessionUsesCurrentCart = false;
    },

    proxyBase: function () {
      var widget = this.firstAuthenticatedWidget() || Array.from(this.widgets)[0];
      return widget ? String(widget.dataset.proxyBase || '').replace(/\/$/, '') : '';
    },

    acceptNativeBudgetHead: function (value) {
      var head;
      try {
        head = nativeBudgetHead(value);
        if (!head) {
          if (this.nativeBudgetExpected) throw nativeBudgetError();
          return 'legacy';
        }
        this.nativeBudgetExpected = true;
        if (this.nativeBudgetHead && head.stateVersion < this.nativeBudgetHead.stateVersion) return 'stale';
        if (this.nativeBudgetHead && head.stateVersion === this.nativeBudgetHead.stateVersion &&
            JSON.stringify(head) !== JSON.stringify(this.nativeBudgetHead)) throw nativeBudgetError();
        this.nativeBudgetHead = head;
        this.nativeBudgetInvalid = false;
        return 'accepted';
      } catch (_error) {
        this.nativeBudgetExpected = true;
        this.nativeBudgetInvalid = true;
        this.markUnknown();
        return 'invalid';
      }
    },

    acceptNativeBudgetMutation: function (value) {
      if (['invalid', 'stale'].includes(this.acceptNativeBudgetHead(value))) {
        this.markUnknown();
        throw nativeBudgetError();
      }
      this.persistAppliedState();
    },

    nativeBudgetEvidence: function () {
      if (!this.nativeBudgetExpected) return {};
      if (this.nativeBudgetInvalid || !this.nativeBudgetHead) throw nativeBudgetError();
      var budget = this.nativeBudgetHead.nativeBudget;
      return {native_budget_id: budget ? budget.id : null,
        native_budget_generation: budget ? budget.generation : 0,
        native_budget_state_version: this.nativeBudgetHead.stateVersion};
    },

    ensureNativeBudgetHead: async function (signal, grant) {
      var redemption = this.summary && this.summary.redemption;
      if (!this.nativeBudgetExpected && (!redemption || !Object.hasOwn(redemption, 'nativeBudgetProtocol'))) return {};
      if (!this.nativeBudgetExpected) this.acceptNativeBudgetHead(redemption);
      if (signal && signal.aborted) throw nativeBudgetError();
      var scope = this.currentCustomerScope();
      var owner = this.summary && this.summary.customer && /^gid:\/\/shopify\/Customer\/([1-9]\d*)$/.exec(String(this.summary.customer.id || ''));
      // This is only a version proposal. Apply still checks the current bank,
      // policy and this exact head under the server's profile/budget locks.
      // A stored head alone or an unresolved operation cannot use this path.
      if (grant && this.summary && this.summary.ok && owner && this.summary.customer.authenticated === true &&
          owner[1] === scope && this.sessionCustomerScope === scope &&
          this.summaryAcceptedRevision > 0 && this.summaryReadFailureRevision === 0 &&
          !this.nativeBudgetInvalid && this.nativeBudgetHead && this.summaryStateVersion === this.nativeBudgetHead.stateVersion &&
          !this.unknownOperation && !this.pendingApply && !this.pendingRevocation && !this.pendingLeaseOperation &&
          !this.settlementPending && !this.legacySessionUnverified && !this.sessionOwnerMismatch &&
          !this.reservationId && !this.applied && !this.nativeAuthorization && !cartHasAuthorization(authoritativeCart()) &&
          (!this.nativeBudgetHead.nativeBudget || this.nativeBudgetHead.nativeBudget.canApply)) return this.nativeBudgetEvidence();
      var previousReadRevision = this.summaryAcceptedRevision;
      var read = this.refreshSummary(null, {preserveCurrent: true});
      var readRevision = this.summaryRequestRevision;
      await read;
      if (signal && signal.aborted) throw nativeBudgetError();
      if (grant && this.summaryReadFailureRevision === readRevision && this.summaryRequestRevision === readRevision) {
        throw Object.assign(new Error('bonus_club_preflight_read_unavailable'), {preflightReadUnavailable: true});
      }
      if (!this.summary || !this.summary.ok || this.nativeBudgetInvalid || !this.nativeBudgetHead ||
          this.summaryStateVersion !== this.nativeBudgetHead.stateVersion || this.summaryAcceptedRevision <= previousReadRevision) {
        this.markUnknown();
        throw nativeBudgetError();
      }
      if (grant && this.nativeBudgetHead.nativeBudget && !this.nativeBudgetHead.nativeBudget.canApply) throw nativeBudgetError();
      return this.nativeBudgetEvidence();
    },

    summaryAuthorizationContext: function (cart) {
      var mechanism = this.nativeAuthorization ? 'single_use_code' : this.authorizationRecovery && this.authorizationRecovery.authorizationMechanism;
      if (this.pendingApply) return {
        cartToken: this.pendingApply.cartToken, cartRevision: this.pendingApply.cartRevision,
        applyOperationId: this.pendingApply.idempotencyKey,
        reservationId: this.reservationId, authorizationDigest: this.binding || null,
        authorizationMechanism: mechanism,
      };
      if (cart && cart.token && cartHasAuthorization(cart)) {
        var known = this.authorizationRecovery;
        var knownMatches = known && known.cartToken === cart.token &&
          known.authorizationDigest === cartBinding(cart) && known.cartRevision === cartRevision(cart);
        return {
          cartToken: cart.token, cartRevision: cartRevision(cart), authorizationDigest: cartBinding(cart),
          reservationId: knownMatches ? known.reservationId : null,
          authorizationMechanism: mechanism,
        };
      }
      var evidence = this.pendingRevocation || this.pendingLeaseOperation && this.pendingLeaseOperation.body;
      if (evidence && evidence.cart_token && evidence.authorization_digest && Number.isSafeInteger(evidence.reservation_id)) return {
        cartToken: evidence.cart_token, cartRevision: evidence.cart_revision,
        authorizationDigest: evidence.authorization_digest, reservationId: evidence.reservation_id,
        authorizationMechanism: mechanism,
      };
      if (this.authorizationRecovery) return this.authorizationRecovery;
      var proof = this.nativeAuthorization && this.nativeAuthorization.proof;
      if (proof && cart && cart.token && proof.reservationId === this.reservationId && proof.authorizationDigest === this.binding) return {
        cartToken: cart.token, cartRevision: proof.cartRevision,
        authorizationDigest: proof.authorizationDigest, reservationId: proof.reservationId,
        authorizationMechanism: 'single_use_code',
      };
      return null;
    },

    loadSummary: function (options) {
      var widget = this.firstAuthenticatedWidget();
      if (!widget) {
        this.renderAll();
        return Promise.resolve(null);
      }
      if (!this.summaryPromise) {
        var trace = bonusOperationTrace('summary');
        var requestRevision = ++this.summaryRequestRevision;
        var requestCart = authoritativeCart();
        var recoveryKey = this.pendingApply && this.pendingApply.idempotencyKey;
        var requestContext = this.summaryAuthorizationContext(requestCart);
        this.summaryRequestPending = true;
        var initialRead = options && options.initialCart ? initialSummaryRequest(requestCart, requestContext) : null;
        this.summaryPromise = (initialRead || requestJson(summaryUrl(this.proxyBase(), requestCart, this.pendingApply, requestContext)))
          .catch(function (error) {
            if (requestRevision === manager.summaryRequestRevision) manager.summaryReadFailureRevision = requestRevision;
            throw error;
          })
          .then(async function (summary) {
            if (requestRevision !== manager.summaryRequestRevision) return manager.summary;
            if (summary && summary.ok !== true) trace('response_rejected', new Error('bonus_club_summary_unconfirmed'));
            var currentCart = authoritativeCart();
            if ((!recoveryKey && ((requestCart && requestCart.token) !== (currentCart && currentCart.token) ||
                cartBinding(requestCart) !== cartBinding(currentCart))) ||
                (recoveryKey && recoveryKey !== (manager.pendingApply && manager.pendingApply.idempotencyKey)) ||
                JSON.stringify(requestContext) !== JSON.stringify(manager.summaryAuthorizationContext(currentCart))) {
              manager.summaryPromise = null;
              return manager.loadSummary();
            }
            var responseOwner = summary && summary.customer && /^gid:\/\/shopify\/Customer\/([1-9]\d*)$/.exec(String(summary.customer.id || ''));
            if (responseOwner && manager.sessionCustomerScope && manager.sessionCustomerScope !== responseOwner[1]) {
              trace('owner_rejected', new Error('bonus_club_authorization_unknown'));
              manager.sessionOwnerMismatch = true;
              manager.summary = {ok: false};
              manager.markUnknown();
              return null;
            }
            if (responseOwner) manager.sessionOwnerMismatch = false;
            var headStatus = manager.acceptNativeBudgetHead(summary && summary.redemption);
            if (headStatus === 'stale' || headStatus === 'invalid') {
              trace(headStatus === 'stale' ? 'head_stale' : 'head_invalid', nativeBudgetError());
              return manager.summary;
            }
            if (headStatus === 'accepted' && manager.summary && manager.summary.ok &&
                manager.summaryStateVersion === manager.nativeBudgetHead.stateVersion &&
                balanceSnapshot(manager.summary) !== balanceSnapshot(summary)) {
              trace('balance_rejected', nativeBudgetError());
              manager.nativeBudgetInvalid = true;
              manager.markUnknown();
              return manager.summary;
            }
            manager.summaryStateVersion = headStatus === 'accepted' ? manager.nativeBudgetHead.stateVersion : null;
            manager.summaryAcceptedRevision = requestRevision;
            manager.summaryReadFailureRevision = 0;
            manager.summary = summary;
            if (headStatus === 'accepted' && !manager.reservationId && !manager.authorizationRecovery &&
                !manager.nativeAuthorization && !manager.pendingApply && !manager.pendingRevocation && !manager.pendingLeaseOperation &&
                !manager.settlementPending && (!manager.nativeBudgetHead.nativeBudget || manager.nativeBudgetHead.nativeBudget.canApply)) {
              manager.unknownOperation = false;
            }
            manager.summaryLoadedAt = Date.now();
            var wasLegacySession = manager.legacySessionUnverified;
            manager.reconcileLegacySessionOwner(summary, requestCart, requestContext);
            if (summary.membership && summary.membership.revocationPending === true) {
              manager.markUnknown();
            } else if (summary.customer && summary.customer.status === 'unsubscribed' &&
                summary.membership && summary.membership.revocationPending === false && !manager.pendingApply && !manager.nativeAuthorization) {
              manager.forgetAuthorization();
            }
            var authorization = summary && summary.redemption && summary.redemption.cartAuthorization;
            var mismatchedAuthorization = authorization && Number.isSafeInteger(authorization.reservationId) &&
              !matchesAuthorizationContext(authorization, requestContext, true);
            if (mismatchedAuthorization) {
              manager.markUnknown();
              authorization = null;
            }
            if (authorization && Number.isSafeInteger(authorization.reservationId)) {
              manager.reservationId = authorization.reservationId;
              manager.authorizationState = authorization.state;
              manager.applicationTitle = authorization.applicationTitle || manager.applicationTitle;
              manager.appliedValueCents = authorization.valueCents;
              manager.authorizationRecovery = {cartToken: requestContext.cartToken, reservationId: authorization.reservationId,
                authorizationDigest: authorization.authorizationDigest, cartRevision: authorization.cartRevision,
                authorizationMechanism: authorization.authorizationMechanism};
              if (manager.pendingApply && authorization.authorizationDigest) {
                manager.binding = authorization.authorizationDigest;
              }
            }
            if (authorization && authorization.authorizationMechanism === 'single_use_code') {
              manager.settlementPending = authorization.settlementPending === true;
              manager.futureUseRevoked = authorization.futureUseRevoked === true;
              var nativeProof = verifiedCodeProof(authorization, {id: authorization.reservationId,
                digest: authorization.authorizationDigest, revision: authorization.cartRevision});
              if (nativeProof) {
                var baselineMatchesRequest = manager.baseline === cartFingerprint(requestCart);
                var promoMatchesRequest = manager.baselinePromo === promoFingerprint(requestCart);
                manager.nativeAuthorization = {code: nativeProof.code, proof: nativeProof,
                  currencyCode: authorization.currencyCode, applicationTitle: authorization.applicationTitle};
                if (baselineMatchesRequest) manager.baseline = cartFingerprint(requestCart);
                if (promoMatchesRequest) manager.baselinePromo = promoFingerprint(requestCart);
              }
              if ((!nativeProof && authorization.active) || manager.settlementPending || authorization.projectionPending) manager.markUnknown();
            } else if (authorization && authorization.active && manager.nativeAuthorization) manager.markUnknown();
            if (manager.applied && authorization && authorization.active === true && authorization.requiresReapply !== true &&
                Number.isSafeInteger(authorization.points) && authorization.points > 0) {
              manager.appliedPoints = authorization.points;
              manager.persistAppliedState();
            }
            if (!manager.operation && !mismatchedAuthorization) await manager.reconcileCartAuthorization(summary, requestCart, requestContext);
            if (wasLegacySession && !manager.legacySessionUnverified && (manager.reservationId || manager.pendingApply || manager.pendingRevocation || manager.pendingLeaseOperation)) manager.persistAppliedState();
            if (requestRevision !== manager.summaryRequestRevision) return manager.summary;
            if (summary && summary.ok) readTiming('summary_accepted');
            manager.renderAll();
            manager.widgets.forEach(function (entry) {
              if (entry.dataset.context === 'account' &&
                  entry.dataset.historyVersion !== String(summary.balance && summary.balance.ledgerVersion)) {
                entry.dataset.historyLoaded = 'false';
                manager.loadHistory(entry);
              }
            });
            if (headStatus === 'accepted') manager.persistAppliedState();
            return manager.recordEnrollmentIntent(summary, manager.firstEnrollmentWidget());
          })
          .catch(function (error) {
            trace('rejected', error);
            if (requestRevision !== manager.summaryRequestRevision) return manager.summary;
            manager.summary = {ok: false};
            manager.renderAll();
            return null;
          }).finally(function () {
            if (requestRevision === manager.summaryRequestRevision) manager.summaryRequestPending = false;
          });
      }
      return this.summaryPromise;
    },

    refreshSummary: function (reason, options) {
      options = options || {};
      if (options.coalesce && (this.summaryRequestPending ||
          Date.now() - this.summaryLoadedAt < SUMMARY_FRESHNESS_MILLISECONDS)) return this.loadSummary();
      var preserveCurrent = options && options.preserveCurrent === true;
      if (!preserveCurrent) this.summary = null;
      this.summaryPromise = null;
      if (!preserveCurrent) this.renderAll(reason);
      return this.loadSummary();
    },

    syncEmailConfirmationStatus: function () {
      if (!hasPendingEmailConfirmation()) return;
      if (emailConfirmationPending(this.summary)) {
        this.emailConfirmationSent = emailConfirmationResendCooldownRemaining() > 0;
        this.scheduleEmailConfirmationResend();
        this.renderAll();
        this.beginCustomerStatusWatch(false);
        return;
      }
      clearEmailConfirmationPending();
      this.emailConfirmationSent = false;
      this.clearEmailConfirmationResendTimer();
      notifyMembershipChanged('customer_status');
    },

    clearEmailConfirmationResendTimer: function () {
      if (this.emailConfirmationResendTimer === null) return;
      clearTimeout(this.emailConfirmationResendTimer);
      this.emailConfirmationResendTimer = null;
    },

    scheduleEmailConfirmationResend: function () {
      this.clearEmailConfirmationResendTimer();
      var remaining = emailConfirmationResendCooldownRemaining();
      if (remaining <= 0) return;
      this.emailConfirmationResendTimer = setTimeout(function () {
        manager.emailConfirmationResendTimer = null;
        manager.emailConfirmationSent = emailConfirmationResendCooldownRemaining() > 0;
        manager.renderAll();
        if (manager.emailConfirmationSent) manager.scheduleEmailConfirmationResend();
      }, Math.min(1_000, remaining));
    },

    onCustomerStatusResume: function (event) {
      if (this.initialized && !initialCartContextReady) return;
      if (event && event.type === 'pageshow' && event.persisted && this.checkoutPrepared) this.checkoutReturnedByNavigation = true;
      if (document.visibilityState === 'hidden' || this.operation) return;
      if (hasPendingEmailConfirmation()) this.beginCustomerStatusWatch(true);
      else if (this.summary && this.firstAuthenticatedWidget()) {
        if (event && event.type === 'pageshow' && event.persisted === false &&
            this.summary.ok === true && this.summaryAcceptedRevision > 0 && this.summaryReadFailureRevision === 0 &&
            !this.unknownOperation) return;
        if (this.resumePromise) return this.resumePromise;
        if (Date.now() - this.summaryLoadedAt < SUMMARY_FRESHNESS_MILLISECONDS) return this.loadSummary();
        this.resumePromise = Promise.resolve().then(async function () {
          var store = window.CartStore;
          if (store && typeof store.refresh === 'function') {
            var previousFingerprint = cartFingerprint(authoritativeCart());
            var fresh = await store.refresh({throwOnError: true}).catch(function () { return null; });
            var cart = authoritativeCart();
            if (fresh && !manager.unknownOperation) {
              if (manager.binding !== cartBinding(cart)) {
                manager.baseline = null;
                manager.baselinePromo = null;
              }
              manager.applied = cartHasAuthorization(cart);
              manager.binding = cartBinding(cart);
            }
            if (fresh && cartFingerprint(cart) !== previousFingerprint) {
              document.dispatchEvent(new CustomEvent('frostix:bonus-club-preview-required', {detail: {serverCart: cart}}));
              refreshCartDrawerSection(cart);
            }
          }
          return manager.refreshSummary(null, {preserveCurrent: true, coalesce: true});
        }).catch(function () {}).finally(function () { manager.resumePromise = null; });
        return this.resumePromise;
      }
    },

    onCartActivity: function (event, options) {
      var activity = event && event.detail && event.detail.activity;
      if (activity === 'cart_opened') {
        // The drawer announces opening before its own deferred active-class update.
        // Let that update finish, then require the actual open container state.
        setTimeout(function () {
          setTimeout(function () {
            var widget = manager.firstEnrollmentWidget();
            if (!widget) return;
            var pending = manager.summaryRequestPending && manager.summaryPromise;
            if (pending) pending.then(function (summary) { return manager.recordEnrollmentIntent(summary, widget); });
            else manager.recordEnrollmentIntent(manager.summary, widget);
          });
        });
      }
      if (activity === 'cart_opened' && event.detail.navigationOpen && this.checkoutReturnNavigationHandled) return;
      if (!['cart_opened', 'cart_changed', 'bonus_applied', 'bonus_removed', 'checkout_started', 'checkout_returned'].includes(activity)) return;
      this.lastActivityAt = Date.now();
      if (activity === 'cart_opened' && this.checkoutReturnedByNavigation && this.authorizationState === 'checkout_pending') {
        activity = 'checkout_returned';
        this.checkoutReturnedByNavigation = false;
      }
      if ((!this.applied && !this.pendingLeaseOperation) || this.operation || (this.unknownOperation && !this.pendingLeaseOperation)) return;
      if (this.authorizationState === 'checkout_pending' && activity !== 'checkout_returned') return;
      if (activity === 'bonus_removed' || activity === 'checkout_started') return;
      var store = window.CartStore;
      if (store && typeof store.hasPending === 'function' && store.hasPending()) return;
      var activityCart = authoritativeCart();
      var context = {scope: this.currentCustomerScope(), reservationId: this.reservationId, binding: this.binding,
        token: activityCart && activityCart.token, revision: cartRevision(activityCart)};
      return this.runFinancial('activity', function (signal) {
        return manager.renewCartLease({activity: activity, signal: signal, beforeMutation: options && options.beforeMutation});
      }).catch(function () {}).finally(function reconcileActivityCart() {
        if (!manager.activityCartChangePending) return;
        if (manager.financialPromise) {
          manager.financialPromise.then(reconcileActivityCart, reconcileActivityCart);
          return;
        }
        manager.activityCartChangePending = false;
        var cart = authoritativeCart();
        if (!cart || context.scope !== manager.currentCustomerScope() || context.reservationId !== manager.reservationId ||
            context.binding !== manager.binding || context.token !== cart.token || context.binding !== cartBinding(cart) ||
            context.revision !== cartRevision(cart)) return;
        manager.onCartChanged({detail: {flushed: true, serverCart: cart}});
      });
    },

    beginCustomerStatusWatch: function (refreshImmediately) {
      if (!this.firstAuthenticatedWidget() || !hasPendingEmailConfirmation()) return;
      this.customerStatusWatchUntil = Date.now() + CUSTOMER_STATUS_WATCH_MILLISECONDS;
      if (this.customerStatusPollTimer !== null) {
        clearTimeout(this.customerStatusPollTimer);
        this.customerStatusPollTimer = null;
      }
      if (refreshImmediately) this.refreshCustomerStatus();
      else this.scheduleCustomerStatusRefresh();
    },

    scheduleCustomerStatusRefresh: function () {
      if (this.customerStatusPollTimer !== null || !hasPendingEmailConfirmation() ||
          Date.now() >= this.customerStatusWatchUntil) return;
      this.customerStatusPollTimer = setTimeout(function () {
        manager.customerStatusPollTimer = null;
        manager.refreshCustomerStatus();
      }, CUSTOMER_STATUS_POLL_INTERVAL_MILLISECONDS);
    },

    refreshCustomerStatus: function () {
      if (this.customerStatusRefreshPromise) return this.customerStatusRefreshPromise;
      if (!hasPendingEmailConfirmation()) return Promise.resolve(null);
      var previousState = customerStateSignature(this.summary);
      this.customerStatusRefreshPromise = this.refreshSummary(null, {preserveCurrent: true})
        .then(function (summary) {
        var nextState = customerStateSignature(summary);
        if (summary && !emailConfirmationPending(summary)) {
          clearEmailConfirmationPending();
          manager.emailConfirmationSent = false;
          manager.clearEmailConfirmationResendTimer();
          if (previousState !== nextState) notifyMembershipChanged('customer_status');
          manager.renderAll();
          return summary;
        }
        manager.scheduleCustomerStatusRefresh();
        return summary;
      }).finally(function () {
        manager.customerStatusRefreshPromise = null;
      });
      return this.customerStatusRefreshPromise;
    },

    onToggle: function (widget, checked) {
      if (widget.dataset.authenticated !== 'true') {
        var guestToggle = widget.querySelector('[data-bonus-toggle]');
        if (guestToggle) guestToggle.checked = false;
        if (checked) this.openGuestDialog(widget);
        return;
      }
      if (this.operation) {
        widget.querySelector('[data-bonus-toggle]').checked = this.applied;
        return;
      }
      if (checked) this.apply(widget);
      else this.remove(widget, 'off');
    },

    onEarningPreview: function (event) {
      var detail = event && event.detail || {};
      if (detail.surface !== 'cart') return;
      if (detail.fingerprint && detail.fingerprint !== cartFingerprint(authoritativeCart())) return;
      this.redemptionPreviewFingerprint = detail.fingerprint || null;
      this.earningPreviewFailed = detail.unavailable === true;
      var preview = detail.redemptionPreview;
      this.redemptionPreviewReason = preview && typeof preview.reason === 'string'
        ? preview.reason
        : null;
      this.redemptionPreviewPoints = preview && preview.allowed === true &&
          Number.isSafeInteger(preview.appliedPointsSnapshot) && preview.appliedPointsSnapshot > 0
        ? preview.appliedPointsSnapshot
        : null;
      var rule = detail.rule;
      if (rule) {
        this.guestOffer = Number.isSafeInteger(rule.welcomeBonusPoints) &&
            rule.welcomeBonusPoints > 0 &&
            Number.isSafeInteger(rule.pointsPerCurrencyUnit) && rule.pointsPerCurrencyUnit > 0 &&
            /^[A-Z]{3}$/.test(String(rule.currencyCode || ''))
          ? {
              welcomeBonusPoints: rule.welcomeBonusPoints,
              pointsPerCurrencyUnit: rule.pointsPerCurrencyUnit,
              currencyCode: rule.currencyCode,
            }
          : null;
      }
      this.renderAll();
    },

    openGuestDialog: function (widget) {
      var dialog = widget.querySelector('[data-bonus-guest-dialog]');
      if (!dialog || !this.guestOffer || typeof dialog.showModal !== 'function') return;
      var title = dialog.querySelector('[data-bonus-guest-welcome-title]');
      var conversionPoints = dialog.querySelector('[data-bonus-guest-conversion-points]');
      var conversionAmount = dialog.querySelector('[data-bonus-guest-conversion-amount]');
      if (title) {
        title.textContent = String(title.dataset.template || '')
          .replace('__POINTS__', points(this.guestOffer.welcomeBonusPoints));
      }
      if (conversionPoints) {
        conversionPoints.textContent = points(this.guestOffer.pointsPerCurrencyUnit);
      }
      if (conversionAmount) {
        conversionAmount.textContent = currencyUnit(this.guestOffer.currencyCode);
      }
      dialog.showModal();
    },

    showEmailConfirmationSent: function (widget) {
      markEmailConfirmationPending();
      this.emailConfirmationSent = true;
      this.scheduleEmailConfirmationResend();
      this.renderAll();
      this.beginCustomerStatusWatch(false);
      var accountWidget = Array.from(this.widgets).find(function (candidate) {
        return candidate.dataset && candidate.dataset.context === 'account';
      });
      if (widget.dataset && widget.dataset.context === 'cart' && accountWidget) return;
      var dialogAlreadyOpen = Array.from(this.widgets).some(function (candidate) {
        var candidateDialog = candidate.querySelector('[data-bonus-email-confirmation-dialog]');
        return Boolean(candidateDialog && candidateDialog.open);
      });
      if (dialogAlreadyOpen) return;
      var dialog = widget.querySelector('[data-bonus-email-confirmation-dialog]');
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    },

    persistAppliedState: function () {
      saveState({
        binding: this.binding,
        fingerprint: this.baseline,
        promoFingerprint: this.baselinePromo,
        appliedPoints: this.appliedPoints,
        reservationId: this.reservationId,
        pendingApply: this.pendingApply,
        pendingRevocation: this.pendingRevocation,
        nativeAuthorization: this.nativeAuthorization,
        nativeBudgetExpected: this.nativeBudgetExpected,
        nativeBudgetCustomerScope: this.firstAuthenticatedWidget() && this.firstAuthenticatedWidget().dataset.customerScope || this.nativeBudgetCustomerScope,
        nativeBudgetHead: this.nativeBudgetHead,
        nativeBudgetInvalid: this.nativeBudgetInvalid,
        pendingRevocationAuthorization: this.pendingRevocationAuthorization,
        pendingLeaseOperation: this.pendingLeaseOperation,
        authorizationRecovery: this.authorizationRecovery,
        settlementPending: this.settlementPending,
        futureUseRevoked: this.futureUseRevoked,
        unknownOperation: this.unknownOperation,
        applicationTitle: this.applicationTitle,
        appliedValueCents: this.appliedValueCents,
        authorizationState: this.authorizationState,
        checkoutPrepared: this.checkoutPrepared,
      });
    },

    stopCartLease: function () {
      if (this.leaseTimer !== null) clearTimeout(this.leaseTimer);
      this.leaseTimer = null;
      this.leaseRefreshAfterSeconds = null;
    },

    startCartLease: function (refreshAfterSeconds) {
      this.stopCartLease();
      if (!this.applied || this.authorizationState === 'checkout_pending' ||
          !Number.isSafeInteger(refreshAfterSeconds) || refreshAfterSeconds <= 0) return;
      this.leaseRefreshAfterSeconds = refreshAfterSeconds;
    },

    renewCartLease: async function (options) {
      options = options || {};
      this.leaseTimer = null;
      if (!this.applied && !this.pendingLeaseOperation) return false;
      if (!options.activity || (this.unknownOperation && !this.pendingLeaseOperation)) return false;
      var cart = authoritativeCart();
      if (!cart || !cart.token || !cartHasAuthorization(cart)) {
        this.stopCartLease();
        return false;
      }
      try {
        if (!this.pendingLeaseOperation) {
          var store = window.CartStore;
          var context = {scope: this.currentCustomerScope(), reservationId: this.reservationId, binding: this.binding,
            token: cart.token, revision: cartRevision(cart), fingerprint: cartFingerprint(cart)};
          if (store && typeof store.hasPending === 'function' && store.hasPending()) return false;
          await this.ensureNativeBudgetHead(options.signal, false);
          var current = authoritativeCart();
          if (!current || (store && typeof store.hasPending === 'function' && store.hasPending()) || this.unknownOperation ||
              context.scope !== this.currentCustomerScope() || context.reservationId !== this.reservationId ||
              context.binding !== this.binding || context.token !== current.token || context.binding !== cartBinding(current) ||
              context.revision !== cartRevision(current)) return false;
          if (context.fingerprint !== cartFingerprint(current) || (this.baseline && cartFingerprint(current) !== this.baseline)) {
            this.activityCartChangePending = true;
            return false;
          }
          cart = current;
        }
        if (this.nativeAuthorization) {
          if (typeof options.beforeMutation === 'function') options.beforeMutation();
          this.pendingLeaseOperation = this.pendingLeaseOperation || {path: '/redemption-renew', mode: 'cart',
            body: Object.assign(this.authorizationEvidence(cart), {activity: options.activity})};
          this.persistAppliedState();
          var nativeLease = await this.completePendingLeaseOperation(options.signal);
          if (!nativeLease) return false;
          this.startCartLease(nativeLease.refreshAfterSeconds);
          return true;
        }
        var lease = await requestJson(this.proxyBase() + '/redemption-renew', {
          method: 'POST',
          body: JSON.stringify(Object.assign(this.authorizationEvidence(cart), {activity: options.activity})),
          signal: options.signal,
        });
        this.acceptNativeBudgetMutation(lease);
        this.authorizationState = lease.state;
        this.startCartLease(lease.refreshAfterSeconds);
        return true;
      } catch (error) {
        if (options.signal && options.signal.aborted) return false;
        var retryable = error && error.body && error.body.error && error.body.error.retryable === true;
        if (retryable) return false;
        this.stopCartLease();
        if (this.pendingLeaseOperation) this.markUnknown();
        if (!options.suppressSummaryRefresh) await this.refreshSummary('recalculating');
        return false;
      }
    },

    authorizationEvidence: function (cart, authorization, operationId, allowLegacy) {
      var currentAuthorization = this.summary && this.summary.redemption && this.summary.redemption.cartAuthorization;
      var summaryMatches = currentAuthorization && currentAuthorization.reservationId === this.reservationId &&
        currentAuthorization.authorizationDigest === this.binding;
      var state = authorization || {
        id: this.reservationId,
        digest: this.binding || cartBinding(cart),
        revision: (cartBinding(cart) === this.binding && cartRevision(cart)) ||
          (summaryMatches && currentAuthorization.cartRevision) || this.pendingApply && this.pendingApply.cartRevision,
      };
      var legacy = allowLegacy && currentAuthorization && currentAuthorization.reservationId === state.id &&
        currentAuthorization.authorizationDigest === state.digest &&
        currentAuthorization.requiresReapply === true && currentAuthorization.cartRevision === null;
      if (!cart || !cart.token || !Number.isSafeInteger(state.id) || state.id <= 0 || !state.digest || (!state.revision && !legacy)) {
        throw new Error('bonus_club_authorization_unknown');
      }
      return Object.assign({
        cart_token: state.cartToken || this.pendingApply && this.pendingApply.cartToken || cart.token,
        reservation_id: state.id,
        authorization_digest: state.digest,
        cart_revision: legacy ? null : state.revision,
        idempotency_key: operationId || technicalId('theme-operation'),
        ...(legacy ? {legacy_reapply: true} : {}),
      }, this.nativeBudgetEvidence());
    },

    forgetAuthorization: function () {
      if (this.legacySessionUnverified) { this.markUnknown(); return; }
      this.applied = false;
      this.appliedPoints = null;
      this.reservationId = null;
      this.authorizationState = null;
      this.checkoutPrepared = false;
      this.checkoutReturnedByNavigation = false;
      this.applicationTitle = null;
      this.appliedValueCents = null;
      this.nativeAuthorization = null;
      this.pendingLeaseOperation = null;
      this.authorizationRecovery = null;
      this.settlementPending = false;
      this.futureUseRevoked = false;
      this.binding = '';
      this.baseline = null;
      this.baselinePromo = null;
      this.pendingApply = null;
      this.pendingRevocation = null;
      this.pendingRevocationAuthorization = null;
      this.unknownOperation = false;
      this.stopCartLease();
      if (this.nativeBudgetExpected) this.persistAppliedState();
      else saveState(null);
    },

    markUnknown: function () {
      this.unknownOperation = true;
      this.persistAppliedState();
      this.summaryLoadedAt = 0;
      this.renderAll();
    },

    adoptNativeAuthorization: function (response, mode) {
      var revision = this.pendingApply && this.pendingApply.cartRevision || cartRevision(authoritativeCart());
      var proof = verifiedCodeProof(response, {id: this.reservationId, digest: this.binding, revision: revision}, mode);
      var budget = this.nativeBudgetHead && this.nativeBudgetHead.nativeBudget;
      if (this.nativeBudgetExpected && (!budget || budget.state !== 'unresolved' ||
          !proof || budget.currentReservationId !== proof.reservationId || budget.generation !== proof.generation)) proof = null;
      if (!proof) {
        this.settlementPending = response && response.settlementPending === true;
        this.markUnknown();
        return false;
      }
      var previous = this.nativeAuthorization || {};
      this.nativeAuthorization = {code: proof.code, proof: proof,
        currencyCode: response.currencyCode || previous.currencyCode,
        applicationTitle: response.discountObservation && response.discountObservation.applicationTitle || response.applicationTitle || previous.applicationTitle};
      this.settlementPending = false;
      this.futureUseRevoked = false;
      this.persistAppliedState();
      return true;
    },

    observeNativeAuthorization: async function (signal, attributes, expectedFingerprint) {
      var native = this.nativeAuthorization;
      if (!native || !window.CartStore || !/^[A-Z]{3}$/.test(String(native.currencyCode || ''))) throw new Error('bonus_club_code_proof_unavailable');
      var cart = attributes
        ? await writeCartAttributes(attributes, {signal: signal, expectedFingerprint: expectedFingerprint, discountCode: native.code})
        : await window.CartStore.applyDiscountCode(native.code, {bonusInternal: true, signal: signal});
      if (signal && signal.aborted) throw Object.assign(new Error('cancelled'), {name: 'AbortError'});
      var ownCodeEntry = (cart && cart.discount_codes || []).find(function (entry) {
        return entry && normalizeCode(entry.code) === normalizeCode(native.code);
      });
      if (attributes && cart && cart.currency === native.currencyCode && expectedFingerprint &&
          cartFingerprint(cart) === expectedFingerprint && cartBinding(cart) === attributes[BONUS_BINDING_KEY] &&
          cartRevision(cart) === attributes[BONUS_REVISION_KEY] && ownCodeEntry && applicableCodes(cart).length === 0 &&
          (ownCodeEntry.applicable === false || bonusAllocationCents(cart, native.applicationTitle, native.code) === 0)) {
        // Observe the submitted mutation once before treating its rejected code
        // or zero allocation as final. Never replay its POST or financial operation.
        await window.CartStore.refresh({throwOnError: true});
        if (signal && signal.aborted) throw Object.assign(new Error('cancelled'), {name: 'AbortError'});
        cart = authoritativeCart();
      }
      if (!cart || cart.currency !== native.currencyCode ||
          bonusAllocationCents(cart, native.applicationTitle, native.code) !== this.appliedValueCents ||
          (attributes && (cartBinding(cart) !== attributes[BONUS_BINDING_KEY] ||
            cartRevision(cart) !== attributes[BONUS_REVISION_KEY] || cartFingerprint(cart) !== expectedFingerprint)) ||
          (this.baseline && cartFingerprint(cart) !== this.baseline)) throw new Error('bonus_club_code_allocation_unconfirmed');
      return cart;
    },

    completePendingLeaseOperation: async function (signal) {
      var pending = this.pendingLeaseOperation;
      if (!pending) return null;
      if (!['/redemption-renew', '/redemption-checkout-start'].includes(pending.path) ||
          !['cart', 'checkout'].includes(pending.mode)) throw new Error('bonus_club_pending_operation_invalid');
      var response = await requestJson(this.proxyBase() + pending.path, {
        method: 'POST', body: JSON.stringify(pending.body), signal: signal,
      });
      this.acceptNativeBudgetMutation(response);
      if (response.state !== (pending.mode === 'checkout' ? 'checkout_pending' : 'reserved') ||
          !this.adoptNativeAuthorization(response, pending.mode)) { this.markUnknown(); return null; }
      await this.observeNativeAuthorization(signal);
      this.authorizationState = response.state;
      this.checkoutPrepared = pending.mode === 'checkout';
      this.applied = true;
      this.unknownOperation = false;
      this.pendingLeaseOperation = null;
      this.persistAppliedState();
      this.broadcastChange();
      return response;
    },

    cleanupRevokedCartAuthorization: async function (evidence, revokedAuthorization, signal, options) {
      this.assertSessionMutationAllowed();
      var expectedCustomerScope = this.currentCustomerScope();
      var combinedHead = options && options.combinedNativeClear === true && this.nativeBudgetExpected && !this.nativeBudgetInvalid
        ? nativeBudgetHead(this.nativeBudgetHead) : null;
      if (combinedHead) combinedHead = JSON.stringify(combinedHead);
      var store = window.CartStore;
      if (store && typeof store.refresh === 'function') await store.refresh({throwOnError: true});
      if (signal && signal.aborted) throw Object.assign(new Error('cancelled'), {name: 'AbortError'});
      this.assertSessionMutationAllowed();
      if (this.currentCustomerScope() !== expectedCustomerScope) throw new Error('bonus_club_authorization_unknown');
      var currentCart = authoritativeCart();
      var budget = this.nativeBudgetHead && this.nativeBudgetHead.nativeBudget;
      var newerBudgetAuthorization = this.nativeBudgetExpected && budget &&
        (budget.id !== evidence.native_budget_id || (budget.currentReservationId !== null && budget.currentReservationId !== evidence.reservation_id));
      var sameCartAuthorization = currentCart && currentCart.token === evidence.cart_token &&
        cartBinding(currentCart) === evidence.authorization_digest && (evidence.legacy_reapply || cartRevision(currentCart) === evidence.cart_revision);
      var ownCode = revokedAuthorization && revokedAuthorization.reservationId === evidence.reservation_id &&
        revokedAuthorization.authorizationDigest === evidence.authorization_digest && revokedAuthorization.cartRevision === evidence.cart_revision
        ? revokedAuthorization.code : null;
      var combinedCleared = false;
      if (ownCode && sameCartAuthorization && !newerBudgetAuthorization && reportedCodes(currentCart).includes(normalizeCode(ownCode))) {
        var expectedCodes = JSON.stringify([reportedCodes(currentCart), enteredCodes(currentCart)]);
        var remainingCodes = enteredCodes(currentCart).filter(function (code) { return code !== normalizeCode(ownCode); });
        var controller = this;
        var beforeMutation = function (latestCart) {
          controller.assertSessionMutationAllowed();
          var latestBudget = controller.nativeBudgetHead && controller.nativeBudgetHead.nativeBudget;
          if (controller.currentCustomerScope() !== expectedCustomerScope || !latestCart || latestCart.token !== evidence.cart_token ||
              cartBinding(latestCart) !== evidence.authorization_digest || cartRevision(latestCart) !== evidence.cart_revision ||
              JSON.stringify([reportedCodes(latestCart), enteredCodes(latestCart)]) !== expectedCodes ||
              (controller.nativeBudgetExpected && latestBudget && (latestBudget.id !== evidence.native_budget_id ||
                (latestBudget.currentReservationId !== null && latestBudget.currentReservationId !== evidence.reservation_id)))) {
            throw new Error('bonus_club_cart_changed_during_removal');
          }
        };
        // A confirmed current native revocation can clear its code and attributes together.
        var native = this.nativeAuthorization;
        var nativeProof = native && native.proof;
        if (combinedHead && !evidence.legacy_reapply && native && normalizeCode(native.code) === normalizeCode(ownCode) &&
            nativeProof && nativeProof.reservationId === evidence.reservation_id && nativeProof.authorizationDigest === evidence.authorization_digest &&
            nativeProof.cartRevision === evidence.cart_revision) {
          var nativeIdentity = JSON.stringify(native);
          var checkNativeFence = function () {
            controller.assertSessionMutationAllowed();
            if (controller.currentCustomerScope() !== expectedCustomerScope || !controller.nativeBudgetExpected || controller.nativeBudgetInvalid ||
                JSON.stringify(nativeBudgetHead(controller.nativeBudgetHead)) !== combinedHead ||
                JSON.stringify(controller.nativeAuthorization) !== nativeIdentity) throw new Error('bonus_club_cart_changed_during_removal');
          };
          var checkCombined = function (latestCart) { beforeMutation(latestCart); checkNativeFence(); };
          var clearAttributes = {};
          clearAttributes[BONUS_BINDING_KEY] = null;
          clearAttributes[BONUS_REVISION_KEY] = null;
          var sentFingerprint;
          var verifyCleared = function (updatedCart) {
            checkNativeFence();
            if (!updatedCart || !Number.isSafeInteger(updatedCart.item_count) || updatedCart.item_count < 0 || !Array.isArray(updatedCart.items) ||
                !Array.isArray(updatedCart.discount_codes) || !updatedCart.attributes || typeof updatedCart.attributes !== 'object' ||
                Array.isArray(updatedCart.attributes) || updatedCart.token !== evidence.cart_token || cartBinding(updatedCart) || cartRevision(updatedCart) ||
                updatedCart.discount_codes.some(function (entry) { return entry && normalizeCode(entry.code) === normalizeCode(ownCode); }) ||
                JSON.stringify(enteredCodes(updatedCart)) !== JSON.stringify(remainingCodes) || cartFingerprint(updatedCart) !== sentFingerprint) {
              throw new Error('bonus_club_code_removal_unknown');
            }
          };
          currentCart = await writeCartAttributes(clearAttributes, {signal: signal, expectedAuthorization: evidence,
            expectedCustomerScope: expectedCustomerScope, discountCode: remainingCodes.join(','),
            beforeMutation: function (latestCart) { checkCombined(latestCart); sentFingerprint = cartFingerprint(latestCart); },
            verifyResponse: function (updatedCart, latestCart) {
              checkCombined(latestCart);
              verifyCleared(updatedCart);
              if (cartFingerprint(latestCart) !== sentFingerprint) throw new Error('bonus_club_code_removal_unknown');
            }});
          verifyCleared(currentCart);
          combinedCleared = true;
        } else {
          // A later successful promo belongs to the customer; remove only this exact native code.
          currentCart = await store.applyDiscountCode(remainingCodes.join(','), {bonusInternal: true, signal: signal,
            beforeMutation: beforeMutation});
        }
        if (reportedCodes(currentCart).includes(normalizeCode(ownCode))) throw new Error('bonus_club_code_removal_unknown');
      }
      if (!combinedCleared && !newerBudgetAuthorization && currentCart && currentCart.token === evidence.cart_token && cartBinding(currentCart) === evidence.authorization_digest &&
          (evidence.legacy_reapply || cartRevision(currentCart) === evidence.cart_revision)) {
        var attributes = {};
        attributes[BONUS_BINDING_KEY] = null;
        attributes[BONUS_REVISION_KEY] = null;
        currentCart = await writeCartAttributes(attributes, {signal: signal, expectedAuthorization: evidence,
          expectedCustomerScope: expectedCustomerScope});
      }
      return {cart: currentCart, newerAuthorization: Boolean(newerBudgetAuthorization ||
        (currentCart && cartBinding(currentCart) && cartBinding(currentCart) !== evidence.authorization_digest))};
    },

    revokeAuthorization: async function (cart, authorization, signal, trace, beforeMutation) {
      trace = trace || function () {};
      var evidence = this.pendingRevocation;
      if (!evidence) {
        await this.ensureNativeBudgetHead(signal, false);
        if (typeof beforeMutation === 'function') beforeMutation();
        trace('evidence');
        evidence = this.authorizationEvidence(cart, authorization, null, true);
        this.pendingRevocation = evidence;
      } else trace('evidence');
      var proof = this.nativeAuthorization && this.nativeAuthorization.proof;
      if (!this.pendingRevocationAuthorization && proof && proof.reservationId === evidence.reservation_id &&
          proof.authorizationDigest === evidence.authorization_digest && proof.cartRevision === evidence.cart_revision) {
        this.pendingRevocationAuthorization = {reservationId: proof.reservationId,
          authorizationDigest: proof.authorizationDigest, cartRevision: proof.cartRevision, code: this.nativeAuthorization.code};
      }
      var revokedAuthorization = this.pendingRevocationAuthorization;
      this.persistAppliedState();
      trace('post');
      var result = await requestJson(this.proxyBase() + '/redemption-remove', {
        method: 'POST', body: JSON.stringify(evidence), signal: signal,
      });
      this.acceptNativeBudgetMutation(result);
      var nativeRevoked = result.authorizationMechanism === 'single_use_code' &&
        result.authorizationStatus === 'revoked' && result.projectionPending === false;
      var released = result.status === 'released' && result.revocationPending !== true && result.projectionPending !== true &&
        (!this.nativeBudgetExpected || (nativeRevoked && result.holdRetained === false && result.settlementPending === false));
      if (!released && !nativeRevoked) {
        this.settlementPending = result.settlementPending === true;
        this.markUnknown();
        throw new Error('bonus_club_revocation_pending');
      }
      trace('cleanup');
      var cleanup = await this.cleanupRevokedCartAuthorization(evidence, revokedAuthorization, signal,
        {combinedNativeClear: nativeRevoked && this.nativeBudgetExpected});
      var currentCart = cleanup.cart;
      var newerBudgetAuthorization = cleanup.newerAuthorization;
      if (newerBudgetAuthorization) {
        if (this.reservationId === evidence.reservation_id) this.forgetAuthorization();
        else {
          this.pendingRevocation = null;
          this.pendingRevocationAuthorization = null;
        }
        this.binding = cartBinding(currentCart);
        this.markUnknown();
      } else if (!released && nativeRevoked) {
        // Native EXPIRED + exact projection clear forbids future use, but does not prove
        // no paid order is awaiting its webhook. Keep the financial hold and original evidence.
        this.applied = false;
        this.pendingApply = null;
        this.pendingLeaseOperation = null;
        this.checkoutPrepared = false;
        this.futureUseRevoked = true;
        this.settlementPending = true;
        this.markUnknown();
      } else this.forgetAuthorization();
      this.broadcastChange();
      trace(released && !newerBudgetAuthorization ? 'confirmed' : 'unconfirmed');
      return currentCart;
    },

    recoverPendingApply: async function (signal) {
      var hadPendingApply = Boolean(this.pendingApply);
      if (!hadPendingApply && !this.unknownOperation) return false;
      if (signal && signal.aborted) return false;
      if (this.pendingApply && this.pendingApply.requestBody) {
        try {
          var recovered = await requestJson(this.proxyBase() + '/redemption-apply', {
            method: 'POST', body: JSON.stringify(this.pendingApply.requestBody),
            signal: signal,
          });
          this.acceptNativeBudgetMutation(recovered);
          this.reservationId = recovered.id;
          this.binding = recovered.cartAttribute.value;
          this.appliedPoints = recovered.appliedPoints;
          this.appliedValueCents = recovered.appliedValueCents;
          if (recovered.authorizationMechanism === 'single_use_code') this.adoptNativeAuthorization(recovered, 'cart');
          this.authorizationState = recovered.status;
          this.unknownOperation = true;
          this.persistAppliedState();
          return true;
        } catch (error) {
          if (!error || error.status !== 409) return false;
        }
      }
      await this.refreshSummary(null, {preserveCurrent: true});
      if (signal && signal.aborted) return false;
      var authorization = this.summary && this.summary.redemption && this.summary.redemption.cartAuthorization;
      if (!authorization) return false;
      if (!matchesAuthorizationContext(authorization, this.summaryAuthorizationContext(authoritativeCart()))) return false;
      if (confirmedTerminalAuthorization(authorization, this.summaryAuthorizationContext(authoritativeCart()))) {
        return this.reconcileTerminalAuthorization(authorization, this.summaryAuthorizationContext(authoritativeCart()), signal);
      }
      if (!hadPendingApply) return false;
      if (!Number.isSafeInteger(authorization.reservationId) || !authorization.authorizationDigest || !authorization.cartRevision) return false;
      this.reservationId = authorization.reservationId;
      this.binding = authorization.authorizationDigest;
      this.appliedPoints = authorization.points;
      this.appliedValueCents = authorization.valueCents;
      this.authorizationState = authorization.state;
      this.unknownOperation = true;
      this.persistAppliedState();
      return true;
    },

    prepareCheckout: function (serverCart) {
      var expired = false;
      var timer;
      var preparation = this.runFinancial('checkout', async function (signal) {
        if (expired || signal.aborted) throw new Error('bonus_club_checkout_state_unknown');
        if (manager.pendingLeaseOperation) await manager.completePendingLeaseOperation(signal);
        if (manager.settlementPending && manager.futureUseRevoked) {
          if (cartHasAuthorization(authoritativeCart()) || (manager.nativeAuthorization && enteredCodes(authoritativeCart()).includes(normalizeCode(manager.nativeAuthorization.code)))) {
            await manager.revokeAuthorization(authoritativeCart(), null, signal);
          }
          var ordinaryCart = authoritativeCart() || serverCart;
          var own = manager.nativeAuthorization && manager.nativeAuthorization.code;
          if (!cartHasAuthorization(ordinaryCart) && (!own || !enteredCodes(ordinaryCart).includes(normalizeCode(own)))) return;
        }
        if (manager.pendingApply && manager.unknownOperation) await manager.recoverPendingApply(signal);
        if (manager.unknownOperation) {
          throw new Error('bonus_club_checkout_state_unknown');
        }
        if (!manager.applied) return;
        var cart = authoritativeCart() || serverCart;
        if (!cart || !cart.token || !cartHasAuthorization(cart)) throw new Error('bonus_club_checkout_state_unknown');
        if (cartBinding(cart) !== manager.binding ||
            (manager.baseline && cartFingerprint(cart) !== manager.baseline) ||
            bonusAllocationCents(cart, manager.applicationTitle,
              manager.nativeAuthorization && manager.nativeAuthorization.code) !== manager.appliedValueCents) {
          if (!signal.aborted) manager.markUnknown();
          throw new Error('bonus_club_checkout_state_unknown');
        }
        if (manager.nativeAuthorization) {
          if (manager.checkoutPrepared && manager.nativeAuthorization.proof.mode === 'checkout') return;
          await manager.ensureNativeBudgetHead(signal, false);
          manager.pendingLeaseOperation = {path: '/redemption-checkout-start', mode: 'checkout',
            body: Object.assign(manager.authorizationEvidence(cart), {entered_discount_codes: applicableCodes(cart)})};
          manager.persistAppliedState();
          try {
            if (!await manager.completePendingLeaseOperation(signal)) throw new Error('bonus_club_checkout_state_unknown');
          } catch (nativeError) { manager.markUnknown(); throw nativeError; }
          manager.checkoutReturnedByNavigation = false;
          manager.stopCartLease();
          return;
        }
        var lease;
        try {
          await manager.ensureNativeBudgetHead(signal, false);
          lease = await requestJson(manager.proxyBase() + '/redemption-checkout-start', {
          method: 'POST',
          body: JSON.stringify(Object.assign(manager.authorizationEvidence(cart), {
            entered_discount_codes: applicableCodes(cart),
          })),
          signal: signal,
          });
          manager.acceptNativeBudgetMutation(lease);
        } catch (error) {
          manager.markUnknown();
          throw error;
        }
        if (lease.state !== 'checkout_pending') {
          manager.markUnknown();
          throw new Error('bonus_club_checkout_state_unknown');
        }
        manager.authorizationState = 'checkout_pending';
        manager.checkoutPrepared = true;
        manager.checkoutReturnedByNavigation = false;
        manager.persistAppliedState();
        manager.stopCartLease();
      });
      return Promise.race([preparation, new Promise(function (_resolve, reject) {
        timer = setTimeout(function () {
          expired = true;
          if (manager.financialController) manager.financialController.abort();
          reject(new Error('bonus_club_checkout_state_unknown'));
        }, FINANCIAL_BARRIER_MILLISECONDS);
      })]).catch(function (error) {
        var widget = manager.firstAuthenticatedWidget();
        if (widget) showToast(copy(widget, 'operationUnknown'));
        throw error;
      }).finally(function () { clearTimeout(timer); });
    },

    clearCheckoutAuthorization: async function () {
      throw new Error('bonus_club_authorization_requires_confirmed_revocation');
    },

    compensateApply: async function (cart, authorization, signal) {
      if (signal && signal.aborted) return false;
      if (!authorization && this.pendingApply && !this.reservationId) await this.recoverPendingApply(signal);
      if (!this.reservationId && !authorization) {
        if (!this.pendingApply && !this.unknownOperation) return true;
        this.markUnknown();
        return false;
      }
      try {
        await this.revokeAuthorization(cart, authorization, signal);
        return true;
      } catch (_error) {
        this.markUnknown();
        return false;
      }
    },

    reconcileTerminalAuthorization: async function (authorization, context, signal) {
      if (!confirmedTerminalAuthorization(authorization, context) || this.legacySessionUnverified) return false;
      var currentCart = authoritativeCart();
      var proof = this.nativeAuthorization && this.nativeAuthorization.proof;
      var own = this.pendingRevocationAuthorization || (proof && {reservationId: proof.reservationId,
        authorizationDigest: proof.authorizationDigest, cartRevision: proof.cartRevision, code: this.nativeAuthorization.code});
      var ownMatches = own && own.reservationId === authorization.reservationId &&
        own.authorizationDigest === authorization.authorizationDigest && own.cartRevision === authorization.cartRevision;
      var sameCart = currentCart && currentCart.token === context.cartToken &&
        cartBinding(currentCart) === authorization.authorizationDigest && cartRevision(currentCart) === authorization.cartRevision;
      if (authorization.authorizationMechanism === 'single_use_code' && sameCart) {
        // Financial release does not reprice Shopify's cached cart. Keep the exact
        // own-code identity until its bound quote and attributes are cleaned up.
        if (!ownMatches) { this.markUnknown(); return false; }
        var evidence = Object.assign({cart_token: context.cartToken, reservation_id: authorization.reservationId,
          authorization_digest: authorization.authorizationDigest, cart_revision: authorization.cartRevision}, this.nativeBudgetEvidence());
        this.pendingRevocationAuthorization = own;
        var controller = this;
        var cleanup = async function (cleanupSignal) {
          controller.applied = false;
          controller.futureUseRevoked = true;
          controller.settlementPending = false;
          controller.persistAppliedState();
          try {
            var outcome = await controller.cleanupRevokedCartAuthorization(evidence, own, cleanupSignal);
            var cleaned = outcome.cart;
            if (outcome.newerAuthorization || !cleaned || cleaned.token !== evidence.cart_token ||
                cartBinding(cleaned) === evidence.authorization_digest || enteredCodes(cleaned).includes(normalizeCode(own.code))) {
              controller.markUnknown();
              return false;
            }
            controller.forgetAuthorization();
            controller.redemptionNoticeReason = null;
            controller.lastObservedFingerprint = cartFingerprint(cleaned);
            controller.broadcastChange();
            refreshCartDrawerSection(cleaned).then(function (patched) { if (!patched) notifyRedemptionChanged(cleaned); });
            return true;
          } catch (_error) {
            controller.markUnknown();
            return false;
          }
        };
        return this.operation ? cleanup(signal) : this.runFinancial('terminal_cleanup', cleanup).catch(function () {
          controller.markUnknown(); return false;
        });
      }
      if ((cartBinding(currentCart) && !sameCart) || (ownMatches && enteredCodes(currentCart).includes(normalizeCode(own.code)))) {
        this.markUnknown();
        return false;
      }
      this.forgetAuthorization();
      this.redemptionNoticeReason = null;
      return true;
    },

    reconcileCartAuthorization: async function (summary, requestCart, requestContext) {
      if (this.legacySessionUnverified) { this.markUnknown(); return; }
      var authorization = summary && summary.redemption && summary.redemption.cartAuthorization;
      if (!authorization || this.operation) return;
      var context = requestContext || this.summaryAuthorizationContext(requestCart);
      var currentCart = authoritativeCart();
      if (confirmedTerminalAuthorization(authorization, context) &&
          (!cartBinding(currentCart) || (currentCart.token === context.cartToken &&
            cartBinding(currentCart) === authorization.authorizationDigest &&
            cartRevision(currentCart) === authorization.cartRevision))) {
        await this.reconcileTerminalAuthorization(authorization, context);
        return;
      }
      if (authorization.settlementPending || (this.nativeAuthorization && authorization.projectionPending)) {
        this.settlementPending = authorization.settlementPending === true;
        this.applied = false;
        this.markUnknown();
        return;
      }
      if (authorization.requiresReapply === true) {
        this.markUnknown();
        return;
      }
      if (authorization.active === true) {
        var cart = authoritativeCart();
        var nativeProof = authorization.authorizationMechanism === 'single_use_code'
          ? verifiedCodeProof(authorization, {id: authorization.reservationId, digest: authorization.authorizationDigest,
            revision: authorization.cartRevision}) : null;
        var budget = this.nativeBudgetHead && this.nativeBudgetHead.nativeBudget;
        if (this.nativeBudgetExpected && (!budget || budget.state !== 'unresolved' ||
            budget.currentReservationId !== authorization.reservationId || !nativeProof || budget.generation !== nativeProof.generation)) {
          this.markUnknown();
          return;
        }
        var confirmed = cart && authorization.authorizationDigest === cartBinding(cart) &&
          authorization.cartRevision === cartRevision(cart) &&
          Number.isSafeInteger(authorization.reservationId) && authorization.reservationId > 0 &&
          Number.isSafeInteger(authorization.valueCents) && authorization.valueCents > 0 &&
          ((!this.nativeAuthorization && authorization.authorizationMechanism !== 'single_use_code') || Boolean(nativeProof)) &&
          bonusAllocationCents(cart, authorization.applicationTitle, nativeProof && nativeProof.code) === authorization.valueCents &&
          (!cart.currency || cart.currency === authorization.currencyCode) &&
          (!this.baseline || cartFingerprint(cart) === this.baseline);
        if (!confirmed || this.pendingApply || this.pendingRevocation || this.pendingLeaseOperation) this.markUnknown();
        else {
          this.applied = true;
          this.unknownOperation = false;
          this.binding = authorization.authorizationDigest;
          this.baseline = cartFingerprint(cart);
          this.baselinePromo = promoFingerprint(cart);
          this.appliedPoints = authorization.points;
          this.persistAppliedState();
        }
        return;
      }
      if (!this.applied || authorization.active !== false) return;
      if (this.nativeAuthorization || authorization.authorizationMechanism === 'single_use_code' ||
          authorization.recoveryPending || authorization.projectionPending || authorization.state === 'revocation_pending' || this.pendingApply) {
        this.markUnknown();
        return;
      }
      var expectedBinding = cartBinding(requestCart);
      if (!expectedBinding || cartBinding(authoritativeCart()) !== expectedBinding) return;
      // Passive reads never mutate the shared cart or another tab's authorization.
      this.forgetAuthorization();
      this.redemptionNoticeReason = 'cartChanged';
    },

    apply: function (widget) {
      var trace = bonusOperationTrace('apply');
      var task = this.runFinancial('apply', async function (signal) {
        if (trace.startObservation) trace.startObservation();
        if (manager.settlementPending) throw new Error('bonus_club_settlement_pending');
        manager.redemptionNoticeReason = null;
        manager.renderAll('recalculating');
        var cart = null;
        var authorization = null;
        var previousCodes = [];
        var applyRequestStarted = false;
        try {
          var store = window.CartStore;
          if (!store) throw new Error('bonus_club_cart_store_unavailable');
          await store.ready();
          if (store.hasPending()) await store.flushNow({urgent: true, throwOnError: true});
          if (signal.aborted) return;
          if (manager.unknownOperation || manager.pendingApply) {
            if (!await manager.recoverPendingApply(signal)) throw new Error('bonus_club_authorization_unknown');
            if (manager.reservationId) {
              if (!await manager.compensateApply(authoritativeCart(), null, signal)) throw new Error('bonus_club_authorization_unknown');
            }
            if (manager.settlementPending) throw new Error('bonus_club_settlement_pending');
          }
          trace('read_head');
          var budgetEvidence = await manager.ensureNativeBudgetHead(signal, true);
          cart = authoritativeCart();
          if (!cart || !cart.token) throw new Error('bonus_club_cart_unavailable');
          previousCodes = applicableCodes(cart);
          if (previousCodes.length) {
            if (typeof store.removeDiscountCode !== 'function') throw new Error('bonus_club_promo_remove_unavailable');
            trace('remove_promo');
            await store.removeDiscountCode({bonusInternal: true});
            cart = authoritativeCart();
            if (applicableCodes(cart).length) throw new Error('bonus_club_promo_remove_failed');
            document.dispatchEvent(new CustomEvent('frostix:bonus-club-preview-required', {detail: {serverCart: cart, ensureExactInFlight: true}}));
            trace('preview');
            await manager.waitForCurrentPreview(cart, signal);
          }
          if (!Number.isSafeInteger(manager.redemptionPreviewPoints) || manager.redemptionPreviewPoints <= 0 ||
              (manager.redemptionPreviewFingerprint && manager.redemptionPreviewFingerprint !== cartFingerprint(cart))) {
            throw new Error('bonus_club_redemption_preview_unavailable');
          }
          var requestedPoints = manager.redemptionPreviewPoints;
          var ruleCurrency = manager.summary && manager.summary.redemption && manager.summary.redemption.rule && manager.summary.redemption.rule.currencyCode;
          if (cart.currency && cart.currency !== ruleCurrency) throw new Error('bonus_club_currency_unconfirmed');
          var expectedFingerprint = cartFingerprint(cart);
          var revision = technicalId('cart-revision');
          var applyKey = technicalId('theme-apply');
          var applyBody = Object.assign({cart_token: cart.token, cart_revision: revision, requested_points: requestedPoints,
            entered_discount_codes: [], idempotency_key: applyKey}, budgetEvidence);
          manager.pendingApply = {cartToken: cart.token, cartRevision: revision, idempotencyKey: applyKey,
            fingerprint: expectedFingerprint, requestBody: applyBody};
          manager.persistAppliedState();
          applyRequestStarted = true;
          trace('reserve');
          var response = await requestJson(manager.proxyBase() + '/redemption-apply', {
            method: 'POST',
            body: JSON.stringify(applyBody),
            signal: signal,
          });
          manager.acceptNativeBudgetMutation(response);
          authorization = {id: response.id, digest: response.cartAttribute.value, revision: response.cartRevisionAttribute.value};
          manager.reservationId = response.id;
          manager.binding = authorization.digest;
          manager.authorizationRecovery = {cartToken: cart.token, reservationId: authorization.id,
            authorizationDigest: authorization.digest, cartRevision: authorization.revision,
            authorizationMechanism: response.authorizationMechanism};
          manager.appliedPoints = response.appliedPoints;
          manager.authorizationState = 'reserved';
          manager.appliedValueCents = Number(response.appliedValueCents);
          manager.persistAppliedState();
          if (response.authorizationMechanism === 'single_use_code' && !manager.adoptNativeAuthorization(response, 'cart')) {
            manager.refreshSummary(null, {preserveCurrent: true});
            return;
          }
          if (signal.aborted || cartFingerprint(authoritativeCart()) !== expectedFingerprint) throw new Error('bonus_club_cart_changed_during_apply');
          var attributes = {};
          attributes[response.cartAttribute.key] = response.cartAttribute.value;
          attributes[response.cartRevisionAttribute.key] = response.cartRevisionAttribute.value;
          var observation = response.discountObservation;
          var expectedCents = Number(response.appliedValueCents);
          var title = observation && observation.applicationTitle;
          manager.applicationTitle = title;
          manager.appliedValueCents = expectedCents;
          var ownCode = response.authorizationMechanism === 'single_use_code' && manager.nativeAuthorization && manager.nativeAuthorization.code;
          trace('write_cart');
          var updatedCart = ownCode
            ? await manager.observeNativeAuthorization(signal, attributes, expectedFingerprint)
            : await writeCartAttributes(attributes, {signal: signal, expectedFingerprint: expectedFingerprint});
          var actualCents = bonusAllocationCents(updatedCart, title, ownCode);
          if (actualCents === 0 && cartFingerprint(updatedCart) === expectedFingerprint) {
            updatedCart = await observeDiscountEvidence(attributes, updatedCart, observation,
              {signal: signal, expectedFingerprint: expectedFingerprint, ownCode: ownCode});
            actualCents = bonusAllocationCents(updatedCart, title, ownCode);
          }
          if (signal.aborted || cartFingerprint(updatedCart) !== expectedFingerprint ||
              !Number.isSafeInteger(expectedCents) || expectedCents <= 0 || actualCents !== expectedCents) {
            throw new Error('bonus_club_discount_not_confirmed');
          }
          manager.applied = true;
          manager.unknownOperation = false;
          manager.pendingApply = null;
          manager.baseline = cartFingerprint(updatedCart);
          manager.baselinePromo = promoFingerprint(updatedCart);
          manager.lastObservedFingerprint = manager.baseline;
          manager.persistAppliedState();
          trace('confirmed');
          manager.startCartLease(response.refreshAfterSeconds);
          manager.broadcastChange();
          manager.refreshSummary(null, {preserveCurrent: true});
          refreshCartDrawerSection(updatedCart).then(function (patched) { if (!patched) notifyRedemptionChanged(updatedCart); });
        } catch (_error) {
          trace(null, _error);
          if (signal.aborted) return;
          if (_error && _error.preflightReadUnavailable === true && !applyRequestStarted) {
            manager.refreshSummary(null, {preserveCurrent: true});
            showToast(copy(widget, manager.unknownOperation ? 'operationUnknown' : 'preflightReadError'));
            return;
          }
          if (_error && (_error.cartMoneyUncertain === true || _error.nativeBudgetUnconfirmed === true)) {
            // Shopify may already have accepted this exact discount. A failed
            // pricing read is not evidence that Apply failed: retain its key,
            // provider proof and hold for reconciliation instead of revoking it.
            manager.markUnknown();
            manager.refreshSummary(null, {preserveCurrent: true});
            showToast(copy(widget, 'operationUnknown'));
            return;
          }
          var released;
          if (_error && _error.status === 409 && !authorization && !manager.unknownOperation) {
            manager.pendingApply = null;
            manager.persistAppliedState();
            released = true;
          } else released = await manager.compensateApply(cart || authoritativeCart(), authorization, signal);
          if (released && previousCodes.length && window.CartStore && typeof window.CartStore.applyDiscountCode === 'function') {
            try { await window.CartStore.applyDiscountCode(previousCodes.join(','), {bonusInternal: true}); } catch (_restoreError) {}
          }
          manager.refreshSummary(null, {preserveCurrent: true});
          showToast(copy(widget, manager.unknownOperation ? 'operationUnknown' : 'applyError'));
        } finally {
          if (trace.captureObservationState) trace.captureObservationState(manager.unknownOperation);
        }
      }).catch(function () {
        // A deadline also rejects outside the action's own catch. Keep the
        // recoverable state and consume this UI action's rejected promise.
        showToast(copy(widget, manager.unknownOperation ? 'operationUnknown' : 'applyError'));
      });
      if (trace.finishObservation) task.then(trace.finishObservation, trace.finishObservation);
      return task;
    },

    waitForCurrentPreview: function (cart, signal) {
      var expected = cartFingerprint(cart);
      if (this.redemptionPreviewFingerprint === expected && this.redemptionPreviewPoints > 0) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var timer;
        var done = function (error) {
          clearTimeout(timer);
          document.removeEventListener('frostix:bonus-club-earning-preview', listener);
          signal.removeEventListener('abort', aborted);
          if (error) reject(error); else resolve();
        };
        var listener = function (event) {
          var detail = event.detail;
          if (!detail || detail.surface !== 'cart' || detail.fingerprint !== expected) return;
          if (detail.unavailable === true) {
            done(new Error('bonus_club_redemption_preview_unavailable'));
          } else if (detail.redemptionPreview && typeof detail.redemptionPreview.allowed === 'boolean') done();
        };
        var aborted = function () { done(new Error('bonus_club_request_timeout')); };
        document.addEventListener('frostix:bonus-club-earning-preview', listener);
        signal.addEventListener('abort', aborted, {once: true});
        timer = setTimeout(aborted, READ_TIMEOUT_MILLISECONDS);
      });
    },

    remove: function (widget, reason, options) {
      var trace = bonusOperationTrace('remove');
      var task = this.runFinancial('remove', async function (signal) {
        if (trace.startObservation) trace.startObservation();
        try {
          if (options && typeof options.beforeMutation === 'function') options.beforeMutation();
          trace('prehead');
          if (manager.pendingApply && !manager.reservationId) await manager.recoverPendingApply(signal);
          var cart = authoritativeCart();
          if (!manager.reservationId) {
            await manager.refreshSummary(null, {preserveCurrent: true});
          }
          if (!manager.reservationId && !manager.applied && !manager.unknownOperation) return;
          var updatedCart = await manager.revokeAuthorization(cart, null, signal, trace, options && options.beforeMutation);
          manager.redemptionNoticeReason = reason === 'cartChanged' ? reason : null;
          manager.lastObservedFingerprint = updatedCart ? cartFingerprint(updatedCart) : null;
          manager.refreshSummary(null, {preserveCurrent: true});
          if (updatedCart) refreshCartDrawerSection(updatedCart).then(function (patched) {
            if (!patched) notifyRedemptionChanged(updatedCart);
          });
        } catch (_error) {
          trace(null, _error);
          if (signal.aborted) return;
          manager.markUnknown();
          showToast(copy(widget, 'operationUnknown') || copy(widget, 'removeError'));
        } finally {
          if (trace.captureObservationState) trace.captureObservationState(manager.unknownOperation);
        }
      }).catch(function (error) {
        trace(null, error);
        showToast(copy(widget, manager.unknownOperation ? 'operationUnknown' : 'removeError'));
      });
      if (trace.finishObservation) task.then(trace.finishObservation, trace.finishObservation);
      return task;
    },

    onPromoConfirmed: function (cart) {
      if (!this.applied && !this.pendingApply && !this.unknownOperation) return Promise.resolve(cart);
      return this.runFinancial('promo', async function (signal) {
        if (manager.pendingApply && !manager.reservationId) await manager.recoverPendingApply(signal);
        if (!manager.reservationId && !manager.applied && !manager.unknownOperation) return authoritativeCart() || cart;
        try {
          return await manager.revokeAuthorization(cart, null, signal);
        } catch (error) {
          if (!signal.aborted) manager.markUnknown();
          throw error;
        }
      });
    },

    runPromoAction: function (action) {
      var observer = null;
      var observation = null;
      var outcome = 'unconfirmed';
      try { observer = window.FrostixCartObservability; } catch (_observationError) {}
      var task = this.runFinancial('promo', async function (signal) {
        try { if (observer) observation = observer.startOperation('promo'); } catch (_observationError) {}
        try {
          if (manager.currentCustomerScope() === '0') {
            var guestCart = await action(signal);
            manager.assertPromoMutationAllowed(guestCart);
            outcome = 'ok';
            return guestCart;
          }
          if (manager.pendingApply && !manager.reservationId) await manager.recoverPendingApply(signal);
          if (manager.unknownOperation && !manager.reservationId) throw new Error('bonus_club_authorization_unknown');
          var cart;
          var rejectedPromo = null;
          var assertConfirmedCart;
          try {
            cart = await action(signal);
          } catch (error) {
            if (!error || error.status !== 422 || error.description !== 'PROMO_NOT_APPLICABLE' ||
                !fullGuestPromoCart(error.confirmedCart) ||
                (!manager.reservationId && !manager.applied && !manager.unknownOperation)) throw error;
            cart = error.confirmedCart;
            var confirmedSnapshot = JSON.stringify(cart);
            assertConfirmedCart = function () {
              manager.assertSessionMutationAllowed();
              if (JSON.stringify(authoritativeCart()) !== confirmedSnapshot) {
                manager.markUnknown();
                throw new Error('bonus_club_cart_changed_during_removal');
              }
            };
            assertConfirmedCart();
            rejectedPromo = error;
          }
          var rejectedBonusRemoved = rejectedPromo &&
            (!Number.isSafeInteger(manager.appliedValueCents) || bonusAllocationCents(cart, manager.applicationTitle,
              manager.nativeAuthorization && manager.nativeAuthorization.code) !== manager.appliedValueCents);
          if ((applicableCodes(cart).length || rejectedBonusRemoved) &&
              (manager.reservationId || manager.applied || manager.unknownOperation)) {
            try {
              cart = await manager.revokeAuthorization(cart, null, signal, null, assertConfirmedCart);
            } catch (error) {
              if (!signal.aborted) manager.markUnknown();
              throw error;
            }
          }
          manager.broadcastChange();
          manager.refreshSummary(null, {preserveCurrent: true});
          if (rejectedPromo) throw rejectedPromo;
          outcome = 'ok';
          return cart;
        } catch (error) {
          if (observation) outcome = bonusObservationFailure(error);
          throw error;
        } finally {
          if (observation && manager.unknownOperation) outcome = 'unconfirmed';
        }
      });
      if (observer) task.then(function () { bonusObservationEvent(observation, 'finish', outcome); },
        function () { bonusObservationEvent(observation, 'finish', outcome); });
      return task;
    },

    onCartChanged: function (event) {
      if (this.initialized && !initialCartContextReady) return;
      var detail = event && event.detail || {};
      if (!detail.flushed || !detail.serverCart) return;
      if (this.operation) {
        if (this.operation === 'activity') this.activityCartChangePending = true;
        return;
      }
      var nextFingerprint = cartFingerprint(detail.serverCart);
      if (cartHasAuthorization(detail.serverCart) && cartBinding(detail.serverCart) !== this.binding) {
        this.lastObservedFingerprint = nextFingerprint;
        if (!this.unknownOperation && !this.pendingApply && !this.pendingRevocation && !this.pendingLeaseOperation) {
          this.baseline = null;
          this.baselinePromo = null;
          this.markUnknown();
          this.refreshSummary(null, {preserveCurrent: true, coalesce: true});
        }
        return;
      }
      if (!this.applied) {
        if (nextFingerprint === this.lastObservedFingerprint) return;
        this.lastObservedFingerprint = nextFingerprint;
        this.renderAll();
        return;
      }
      if (nextFingerprint === this.baseline) return;
      this.lastObservedFingerprint = nextFingerprint;
      var widget = this.firstAuthenticatedWidget();
      if (!widget) return;
      var reason = promoFingerprint(detail.serverCart) === this.baselinePromo ? 'cartChanged' : 'promoChanged';
      this.remove(widget, reason);
    },

    renderAll: function (reason) {
      var self = this;
      this.widgets.forEach(function (widget) { self.renderWidget(widget, reason); });
    },

    renderWidget: function (widget, reason) {
      var effectiveReason = reason || this.redemptionNoticeReason;
      var authenticated = widget.dataset.authenticated === 'true';
      var isCart = widget.dataset.context === 'cart';
      var status = widget.querySelector('[data-bonus-status]');
      var member = widget.querySelector('[data-bonus-member]');
      var login = widget.querySelector('[data-bonus-login]');
      var toggleWrap = widget.querySelector('[data-bonus-toggle-wrap]');
      var toggle = widget.querySelector('[data-bonus-toggle]');
      var spinner = widget.querySelector('[data-bonus-spinner]');
      var membershipActions = widget.querySelector('[data-bonus-membership-actions]');
      var learnMore = widget.querySelector('[data-bonus-learn-more]');
      var emailConfirmation = widget.querySelector('[data-bonus-email-confirmation]');
      var emailConfirmationSubmit = widget.querySelector('[data-bonus-email-confirmation-submit]');
      var useInCart = widget.querySelector('[data-bonus-use-in-cart]');
      var support = widget.querySelector('[data-bonus-support]');
      var joinOpen = widget.querySelector('[data-bonus-join-open]');
      var accountValue = widget.querySelector('[data-bonus-account-value]');
      var doiBanner = widget.querySelector('[data-bonus-doi-banner]');
      var effectivePreviewReason = this.redemptionPreviewReason;
      var redemptionPreviewReady = Number.isSafeInteger(this.redemptionPreviewPoints) &&
        this.redemptionPreviewPoints > 0 && (!this.redemptionPreviewFingerprint ||
          this.redemptionPreviewFingerprint === cartFingerprint(authoritativeCart()));
      var promoPresent = applicableCodes(authoritativeCart()).length > 0;
      var budgetBlocksGrant = this.nativeBudgetInvalid || (this.nativeBudgetExpected &&
        this.nativeBudgetHead && this.nativeBudgetHead.nativeBudget && !this.nativeBudgetHead.nativeBudget.canApply);
      if (toggle) {
        toggle.checked = this.applied || (this.unknownOperation && !this.futureUseRevoked);
        toggle.disabled = Boolean(this.operation) || (!this.applied && (!this.unknownOperation || this.futureUseRevoked) && Boolean(budgetBlocksGrant)) || (this.settlementPending && this.futureUseRevoked) ||
          (!this.applied && !this.unknownOperation && isCart && !redemptionPreviewReady && !promoPresent);
      }
      if (login) login.hidden = authenticated || isCart;
      if (member) member.hidden = true;
      if (toggleWrap) toggleWrap.hidden = !this.applied;
      if (spinner) spinner.hidden = !this.operation && this.summary !== null;
      if (membershipActions) membershipActions.hidden = true;
      if (learnMore) learnMore.hidden = true;
      if (emailConfirmation) emailConfirmation.hidden = true;
      if (emailConfirmationSubmit) {
        emailConfirmationSubmit.disabled = this.emailConfirmationSent;
        emailConfirmationSubmit.textContent = this.emailConfirmationSent
          ? copy(widget, 'emailConfirmationPendingAction').replace(
            '__SECONDS__',
            String(Math.max(1, Math.ceil(emailConfirmationResendCooldownRemaining() / 1_000))),
          )
          : hasPendingEmailConfirmation()
            ? copy(widget, 'emailConfirmationResendAction')
            : copy(widget, 'emailConfirmationAction');
      }
      if (useInCart) useInCart.hidden = true;
      if (support) support.hidden = true;
      if (joinOpen) joinOpen.hidden = true;
      if (doiBanner) doiBanner.hidden = true;

      if (!authenticated) {
        if (spinner) spinner.hidden = true;
        if (toggleWrap) toggleWrap.hidden = !isCart;
        if (toggle) {
          toggle.checked = false;
          toggle.disabled = !isCart || !this.guestOffer;
        }
        if (status) {
          status.textContent = isCart && this.guestOffer
            ? pointCopy(widget, 'guestCartAvailable', this.guestOffer.welcomeBonusPoints)
            : isCart && this.earningPreviewFailed
              ? copy(widget, 'unavailable')
              : isCart ? copy(widget, 'loading') : copy(widget, 'login');
        }
        return;
      }
      if (!this.summary) {
        if (status) status.textContent = copy(widget, 'loading');
        if (accountValue) accountValue.textContent = copy(widget, 'loading');
        return;
      }
      if (!this.summary.ok) {
        if (toggleWrap) toggleWrap.hidden = false;
        if (toggle) toggle.disabled = Boolean(this.operation) || (!this.applied && !this.unknownOperation);
        if (status) status.textContent = copy(widget, 'unavailable');
        if (accountValue) accountValue.textContent = copy(widget, 'unavailable');
        return;
      }
      if (this.summary.maintenance && this.summary.maintenance.enabled) {
        if (status) status.textContent = copy(widget, 'maintenance');
        return;
      }
      if (this.summary.customer.status === 'not_enrolled') {
        if (this.enrollmentIntentRequired(this.summary, widget)) {
          var intentAttempt = this.enrollmentIntentAttempt;
          var intentFailed = intentAttempt && !intentAttempt.pending;
          var intentCopy = copy(widget, intentFailed ? 'joinError' : 'loading');
          if (status) status.textContent = intentCopy;
          if (accountValue) accountValue.textContent = intentCopy;
          if (spinner) spinner.hidden = Boolean(intentFailed);
          if (toggleWrap) toggleWrap.hidden = true;
          if (joinOpen && intentFailed) {
            joinOpen.hidden = false;
            joinOpen.textContent = copy(widget, 'joinAction');
          }
          return;
        }
        this.renderJoinAction(widget);
        var welcomeOffer = this.summary.membership && this.summary.membership.welcomeOffer || {};
        var welcomePoints = Number(welcomeOffer.points) || 0;
        if (accountValue) {
          accountValue.replaceChildren(
            document.createTextNode(pointCopy(widget, 'accountOffer', welcomePoints) + ' '),
            bonusIcon(widget)
          );
        }
        if (status) {
          var eligibilityReason = this.summary.membership &&
            this.summary.membership.eligibility &&
            this.summary.membership.eligibility.reason;
          var needsEmailConfirmation = ['newsletter_unconfirmed', 'email_unverified']
            .includes(eligibilityReason);
          if (learnMore) learnMore.hidden = isCart && needsEmailConfirmation;
          if (needsEmailConfirmation) {
            if (eligibilityReason === 'newsletter_unconfirmed') {
              status.textContent = isCart && this.guestOffer && this.emailConfirmationSent
                ? pointCopy(widget, 'emailConfirmationPendingWelcome', this.guestOffer.welcomeBonusPoints)
                : isCart && this.guestOffer
                ? pointCopy(widget, 'newsletterConfirmationWelcome', this.guestOffer.welcomeBonusPoints)
                : copy(widget, 'newsletterConfirmationRequired');
            } else {
              status.textContent = copy(widget, 'emailVerificationRequired');
            }
            if (emailConfirmation) emailConfirmation.hidden = false;
            if (doiBanner) doiBanner.hidden = false;
          } else {
            status.textContent = copy(widget, 'notEnrolled');
          }
        }
        return;
      }

      var customerStatus = this.summary.customer.status;

      if (accountValue) {
        var signedBalance = this.summary.balance.canonicalAvailablePoints;
        var displayedBalance = Number.isSafeInteger(signedBalance) && signedBalance < 0
          ? signedBalance : this.summary.balance.availablePoints;
        var accountBalanceCopy = pointCopy(widget, 'accountBalance', displayedBalance);
        accountValue.replaceChildren(
          document.createTextNode(accountBalanceCopy + ' '),
          bonusIcon(widget)
        );
      }

      if (member) member.hidden = false;
      widget.querySelector('[data-bonus-available]').textContent = points(this.summary.balance.availablePoints);
      widget.querySelector('[data-bonus-pending]').textContent = points(this.summary.balance.pendingPoints);
      widget.querySelector('[data-bonus-redeemed]').textContent = points(this.summary.balance.redeemedPoints);
      var debt = widget.querySelector('[data-bonus-debt]');
      if (debt) {
        debt.hidden = !(this.summary.balance.debtPoints > 0);
        debt.textContent = pointCopy(widget, 'debt', this.summary.balance.debtPoints);
      }
      var nextExpiryRow = widget.querySelector('[data-bonus-next-expiry-row]');
      var nextExpiry = widget.querySelector('[data-bonus-next-expiry]');
      if (nextExpiryRow && nextExpiry) {
        var expiryDate = localDate(this.summary.balance.nextExpiryAt);
        nextExpiryRow.hidden = false;
        var hasExpiringPoints = expiryDate && Number(this.summary.balance.nextExpiryPoints) > 0;
        if (!hasExpiringPoints) nextExpiry.textContent = copy(widget, 'nextExpiryEmpty');
        else if (widget.dataset.context === 'account') nextExpiry.textContent = expiryDate;
        else nextExpiry.textContent = points(this.summary.balance.nextExpiryPoints) + ' · ' + expiryDate;
      }
      if (membershipActions && ['active', 'inactive', 'maintenance_hold'].includes(customerStatus)) {
        membershipActions.hidden = false;
      }
      if (useInCart && !isCart && customerStatus === 'active') useInCart.hidden = false;
      if (support && customerStatus === 'blocked') support.hidden = false;
      this.renderJoinAction(widget);

      var authorization = this.summary.redemption && this.summary.redemption.authorization || {};
      if (toggleWrap) toggleWrap.hidden = false;
      if (toggle) {
        toggle.disabled = Boolean(this.operation) || (!this.applied && (!this.unknownOperation || this.futureUseRevoked) && Boolean(budgetBlocksGrant)) || (this.settlementPending && this.futureUseRevoked) ||
          (!this.applied && !this.unknownOperation && (
            !authorization.allowed ||
            (isCart && !redemptionPreviewReady && !promoPresent)
          ));
      }
      if (status) {
        if (this.settlementPending || (!isCart && this.summary.redemption && this.summary.redemption.settlementPending)) status.textContent = copy(widget, 'settlementPending');
        else if (this.unknownOperation || (!this.applied && budgetBlocksGrant && this.nativeBudgetHead &&
            this.nativeBudgetHead.nativeBudget && ['operation_pending', 'consumed_unattributed', 'review'].includes(this.nativeBudgetHead.nativeBudget.state))) status.textContent = copy(widget, 'operationUnknown');
        else if (customerStatus === 'unsubscribed') {
          status.textContent = copy(widget, 'unsubscribed');
        }
        else if (customerStatus === 'blocked') {
          status.textContent = copy(widget, 'blocked');
        }
        else if (customerStatus === 'inactive') {
          status.textContent = copy(widget, 'inactive');
        }
        else if (this.operation) status.textContent = copy(widget, 'recalculating');
        else if (this.applied) {
          var appliedPoints = Number(this.appliedPoints);
          if (!Number.isSafeInteger(appliedPoints) || appliedPoints <= 0) {
            appliedPoints = Number(this.redemptionPreviewPoints);
          }
          if (!Number.isSafeInteger(appliedPoints) || appliedPoints <= 0) {
            appliedPoints = cartAppliedPoints(authoritativeCart());
          }
          status.textContent = isCart && Number.isSafeInteger(appliedPoints) && appliedPoints > 0
            ? cartPointCopy(widget, 'cartApplied', appliedPoints, this.summary)
            : copy(widget, 'applied');
        }
        else if (isCart && promoPresent) status.textContent = copy(widget, 'promoWillBeRemoved');
        else if (isCart && effectivePreviewReason === 'below_minimum') {
          status.textContent = copy(widget, 'cartBelowMinimum');
        }
        else if (effectiveReason && !(isCart && effectiveReason === 'off' && redemptionPreviewReady)) {
          status.textContent = isCart && effectiveReason === 'cartChanged' && redemptionPreviewReady
            ? cartPointCopy(widget, effectiveReason, this.redemptionPreviewPoints, this.summary)
            : copy(widget, effectiveReason);
        }
        else if (authorization.reason === 'zero_balance') {
          status.textContent = copy(widget, 'zeroBalance');
        }
        else if (!authorization.allowed) status.textContent = copy(widget, 'ineligible');
        else if (isCart && redemptionPreviewReady) {
          status.textContent = cartPointCopy(widget, 'cartAvailable', this.redemptionPreviewPoints, this.summary);
        }

        else if (isCart) status.textContent = this.earningPreviewFailed
          ? copy(widget, 'unavailable')
          : copy(widget, 'loading');
        else status.textContent = copy(widget, 'off');
      }
    },

    renderJoinAction: function (widget) {
      var membership = this.summary && this.summary.membership || {};
      var action = membership.action;
      var joinOpen = widget.querySelector('[data-bonus-join-open]');
      var confirmText = widget.querySelector('[data-bonus-join-confirm-text]');
      if (!joinOpen || membership.revocationPending || !['join', 'reactivate'].includes(action)) return;
      joinOpen.hidden = false;
      joinOpen.dataset.membershipAction = action;
      var actionCopyKey = 'reactivateAction';
      if (action === 'join') actionCopyKey = 'joinAction';
      joinOpen.textContent = copy(widget, actionCopyKey);
      if (confirmText) {
        var confirmCopyKey = 'reactivateConfirm';
        if (action === 'join') confirmCopyKey = 'joinConfirm';
        confirmText.textContent = copy(widget, confirmCopyKey);
      }
    },

    join: async function (widget) {
      if (this.operation) return;
      var dialog = widget.querySelector('[data-bonus-join-dialog]');
      var joinOpen = widget.querySelector('[data-bonus-join-open]');
      var requestedAction = joinOpen && joinOpen.dataset.membershipAction || 'join';
      var membershipChanged = false;
      this.operation = 'join';
      this.renderAll();
      try {
        var result = await requestJson(this.proxyBase() + '/join', {
          method: 'POST',
          body: JSON.stringify({source: manager.enrollmentIntentSource(widget), idempotency_key: technicalId('membership-join')}),
        });
        membershipChanged = true;
        this.summary = null;
        this.summaryPromise = null;
        if (dialog) dialog.close();
        var successCopyKey = 'joinSuccess';
        if (result.projectionPending) successCopyKey = 'joinPending';
        else if (requestedAction === 'reactivate') successCopyKey = 'reactivateSuccess';
        showToast(copy(widget, successCopyKey));
      } catch (error) {
        var code = error && error.body && error.body.error && error.body.error.code;
        var errorCopyKey = 'joinError';
        if (code === 'bonus_club_not_eligible') errorCopyKey = 'joinNotEligible';
        showToast(copy(widget, errorCopyKey));
      } finally {
        this.operation = null;
        await this.loadSummary();
        this.renderAll();
        if (membershipChanged) notifyMembershipChanged(requestedAction);
      }
    },

    unsubscribe: async function (widget) {
      if (this.operation) return;
      var dialog = widget.querySelector('[data-bonus-unsubscribe-dialog]');
      var membershipChanged = false;
      this.operation = 'unsubscribe';
      this.renderAll();
      try {
        var result = await requestJson(this.proxyBase() + '/unsubscribe', {
          method: 'POST',
          body: JSON.stringify({idempotency_key: technicalId('membership-exit')}),
        });
        membershipChanged = true;
        this.broadcastChange();
        if (result.completed === false || result.revocationPending === true || result.projectionPending === true) {
          this.markUnknown();
          this.summary = null;
          this.summaryPromise = null;
          if (dialog) dialog.close();
          showToast(copy(widget, 'unsubscribePending'));
          return;
        }
        var cart = authoritativeCart();
        var cartCleanupPending = false;
        if (cartHasAuthorization(cart)) {
          var attributes = {};
          attributes[BONUS_BINDING_KEY] = null;
          attributes[BONUS_REVISION_KEY] = null;
          try {
            await writeCartAttributes(attributes, {expectedAuthorization: {
              cart_token: cart.token, authorization_digest: cartBinding(cart),
              cart_revision: cartRevision(cart), legacy_reapply: !cartRevision(cart),
            }});
          } catch (_error) {
            cartCleanupPending = true;
          }
        }
        this.forgetAuthorization();
        this.summary = null;
        this.summaryPromise = null;
        if (dialog) dialog.close();
        showToast(copy(widget,
          result.projectionPending || cartCleanupPending ? 'unsubscribePending' : 'unsubscribeSuccess'));
      } catch (_error) {
        showToast(copy(widget, 'unsubscribeError'));
      } finally {
        this.operation = null;
        await this.loadSummary();
        this.renderAll();
        if (membershipChanged) notifyMembershipChanged('unsubscribe');
      }
    },

    loadHistory: function (widget, append) {
      append = Boolean(append);
      var body = widget.querySelector('.cart-block-panel-body');
      if (body && body.hidden) return;
      var version = String(this.summary && this.summary.balance && this.summary.balance.ledgerVersion);
      if ((!append && widget.dataset.historyLoaded === 'true' && widget.dataset.historyVersion === version) ||
          widget.dataset.historyLoading === 'true' || !this.summary || !this.summary.ok ||
          this.summary.customer.status === 'not_enrolled') return;
      var container = widget.querySelector('[data-bonus-history]');
      var list = widget.querySelector('[data-bonus-history-list]');
      var more = widget.querySelector('[data-bonus-history-more]');
      if (!container || !list) return;
      var offset = append ? Math.max(0, Number(widget.dataset.historyOffset) || 0) : 0;
      var cursor = append && widget.dataset.historyCursor;
      widget.dataset.historyLoading = 'true';
      if (more) more.disabled = true;
      container.hidden = false;
      var query = '?limit=' + HISTORY_PAGE_SIZE + (cursor ? '&cursor=' + encodeURIComponent(cursor) : '&offset=' + offset);
      var requestRevision = (widget.historyRequestRevision || 0) + 1;
      widget.historyRequestRevision = requestRevision;
      return requestJson(this.proxyBase() + '/history' + query).then(function (result) {
        if (widget.historyRequestRevision !== requestRevision || version !== String(manager.summary && manager.summary.balance && manager.summary.balance.ledgerVersion)) return;
        var entries = Array.isArray(result.entries) ? result.entries : [];
        if (!append) {
          list.replaceChildren();
          widget.historyEntryIds = new Set();
        }
        if (!widget.historyEntryIds) widget.historyEntryIds = new Set();
        if (entries.length === 0 && offset === 0) {
          var empty = document.createElement('p');
          empty.className = 't3';
          empty.textContent = copy(widget, 'historyEmpty');
          list.appendChild(empty);
        }
        entries.forEach(function (entry) {
          if (widget.historyEntryIds.has(String(entry.id))) return;
          widget.historyEntryIds.add(String(entry.id));
          var row = document.createElement('div');
          var date = document.createElement('span');
          date.className = 't3';
          var entryType = entry.sourceType === 'loyalty_welcome_bonus' ? 'welcome' : entry.entryType;
          var typeKey = 'historyType' + String(entryType || '').replace(/^./, function (letter) { return letter.toUpperCase(); });
          var type = widget.dataset[typeKey] || widget.dataset.historyTypeOther || '';
          var labels = [localDate(entry.createdAt), type];
          var sourceKey = historySourceKey(entry.sourceType);
          if (sourceKey && widget.dataset[sourceKey]) labels.push(widget.dataset[sourceKey]);
          if (entry.availableAt) labels.push(copy(widget, 'historyAvailableAt').replace('__DATE__', localDate(entry.availableAt)));
          if (entry.expiresAt) labels.push(copy(widget, 'historyExpiresAt').replace('__DATE__', localDate(entry.expiresAt)));
          date.textContent = labels.filter(Boolean).join(' · ');
          var value = document.createElement('span');
          value.className = 't3';
          var statusKey = historyStatusKey(entry.status);
          var status = widget.dataset[statusKey] || '';
          if (widget.dataset.context === 'account') {
            row.className = 'frostix-account-bonus-history-row';
            value.className = 't3 frostix-account-bonus-history-points';
            value.textContent = (Number(entry.pointsDelta) > 0 ? '+' : '') + points(entry.pointsDelta);
            var statusNode = document.createElement('span');
            statusNode.className = 't3 frostix-account-bonus-history-status';
            statusNode.textContent = status;
            row.append(date, value, statusNode);
          } else {
            row.className = 'cart-block-panel-row';
            value.textContent = (Number(entry.pointsDelta) > 0 ? '+' : '') + points(entry.pointsDelta) + ' · ' + status;
            row.append(date, value);
          }
          list.appendChild(row);
        });
        widget.dataset.historyLoaded = 'true';
        widget.dataset.historyVersion = version;
        widget.dataset.historyOffset = String(offset + entries.length);
        widget.dataset.historyCursor = typeof result.nextCursor === 'string' ? result.nextCursor : '';
        if (more) more.hidden = !result.hasMore;
      }).catch(function () {
        if (widget.historyRequestRevision !== requestRevision ||
            version !== String(manager.summary && manager.summary.balance && manager.summary.balance.ledgerVersion)) return;
        if (!append) list.replaceChildren();
        var error = document.createElement('p');
        error.className = 't3';
        error.textContent = copy(widget, 'historyError');
        list.appendChild(error);
        if (more) more.hidden = false;
      }).finally(function () {
        if (widget.historyRequestRevision !== requestRevision) return;
        widget.dataset.historyLoading = 'false';
        if (more) more.disabled = false;
        if (version !== String(manager.summary && manager.summary.balance && manager.summary.balance.ledgerVersion)) {
          manager.loadHistory(widget);
        }
      });
    },
  };

  function bonusIcon(widget) {
    var source = widget.dataset.bonusIcon;
    if (!source) return document.createTextNode('');
    var image = document.createElement('img');
    image.src = source;
    image.alt = '';
    image.width = 22;
    image.height = 17;
    return image;
  }

  function historySourceKey(sourceType) {
    if (sourceType === 'shopify_order') return 'historySourceOrder';
    if (sourceType === 'loyalty_welcome_bonus') return 'historySourceMembership';
    if (sourceType === 'admin_adjustment') return 'historySourceStaff';
    if (sourceType === 'loyalty_expiry') return 'historySourceExpiry';
    if (sourceType === 'redemption') return 'historySourceRedemption';
    return null;
  }

  function historyStatusKey(status) {
    var suffix = String(status || '').replace(/(^|_)([a-z])/g, function (_m, _p, letter) {
      return letter.toUpperCase();
    });
    return 'historyStatus' + suffix;
  }

  class FrostixBonusClubElement extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bonusInitialized === 'true') {
        manager.register(this);
        return;
      }
      this.dataset.bonusInitialized = 'true';
      var toggle = this.querySelector('[data-bonus-toggle]');
      if (toggle) toggle.addEventListener('change', function () {
        manager.onToggle(this.closest('frostix-bonus-club'), this.checked);
      });
      var historyMore = this.querySelector('[data-bonus-history-more]');
      if (historyMore) historyMore.addEventListener('click', function () {
        manager.loadHistory(this.closest('frostix-bonus-club'), true);
      });
      var unsubscribeDialog = this.querySelector('[data-bonus-unsubscribe-dialog]');
      var unsubscribeOpen = this.querySelector('[data-bonus-unsubscribe-open]');
      var unsubscribeConfirm = this.querySelector('[data-bonus-unsubscribe-confirm]');
      var unsubscribeCancel = this.querySelector('[data-bonus-unsubscribe-cancel]');
      var joinDialog = this.querySelector('[data-bonus-join-dialog]');
      var joinOpen = this.querySelector('[data-bonus-join-open]');
      var joinConfirm = this.querySelector('[data-bonus-join-confirm]');
      var joinCancel = this.querySelector('[data-bonus-join-cancel]');
      var guestDialog = this.querySelector('[data-bonus-guest-dialog]');
      var guestDialogClose = this.querySelector('[data-bonus-guest-dialog-close]');
      var guestLogin = this.querySelector('.frostix-cart-bonus-guest-login');
      var emailConfirmationForm = this.querySelector('[data-bonus-email-confirmation] form');
      var emailConfirmationInput = this.querySelector('[data-bonus-email-confirmation-input]');
      var emailConfirmationSubmit = this.querySelector('[data-bonus-email-confirmation-submit]');
      var emailConfirmationPosted = this.querySelector('[data-bonus-email-confirmation-posted]');
      var emailConfirmationDialog = this.querySelector('[data-bonus-email-confirmation-dialog]');
      var emailConfirmationClose = this.querySelector('[data-bonus-email-confirmation-close]');
      if (unsubscribeOpen && unsubscribeDialog) unsubscribeOpen.addEventListener('click', function () {
        unsubscribeDialog.showModal();
      });
      if (unsubscribeConfirm) unsubscribeConfirm.addEventListener('click', function () {
        manager.unsubscribe(this.closest('frostix-bonus-club'));
      });
      if (unsubscribeCancel && unsubscribeDialog) unsubscribeCancel.addEventListener('click', function () {
        unsubscribeDialog.close();
      });
      if (joinOpen && joinDialog) joinOpen.addEventListener('click', function () {
        var widget = this.closest('frostix-bonus-club');
        if (manager.enrollmentIntentRequired(manager.summary, widget)) {
          manager.recordEnrollmentIntent(manager.summary, widget, true);
          return;
        }
        joinDialog.showModal();
      });
      if (joinConfirm) joinConfirm.addEventListener('click', function () {
        manager.join(this.closest('frostix-bonus-club'));
      });
      if (joinCancel && joinDialog) joinCancel.addEventListener('click', function () {
        joinDialog.close();
      });
      if (guestDialogClose && guestDialog) guestDialogClose.addEventListener('click', function () {
        guestDialog.close();
      });
      if (guestLogin) guestLogin.addEventListener('click', function () {
        try { sessionStorage.setItem(ENROLLMENT_SOURCE_KEY, JSON.stringify({source: 'cart', createdAt: Date.now()})); } catch (_error) {}
      });
      if (guestDialog) {
        guestDialog.addEventListener('click', function (event) {
          if (event.target === guestDialog) guestDialog.close();
        });
        guestDialog.addEventListener('close', () => {
          var guestToggle = this.querySelector('[data-bonus-toggle]');
          if (guestToggle) guestToggle.focus();
        });
      }
      if (emailConfirmationSubmit && emailConfirmationInput) {
        emailConfirmationSubmit.addEventListener('pointerdown', function () {
          emailConfirmationInput.focus({preventScroll: true});
        }, {capture: true});
      }
      if (emailConfirmationForm && emailConfirmationPosted) {
        window.requestAnimationFrame(() => {
          manager.showEmailConfirmationSent(this);
        });
      }
      if (emailConfirmationClose && emailConfirmationDialog) {
        emailConfirmationClose.addEventListener('click', function () {
          if (emailConfirmationDialog.open) emailConfirmationDialog.close();
          var drawer = this.closest('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          manager.widgets.forEach(function (widget) {
            var dialog = widget.querySelector('[data-bonus-email-confirmation-dialog]');
            if (dialog && dialog.open) dialog.close();
          });
        });
      }
      var panelToggle = this.querySelector('[data-panel-toggle]');
      if (panelToggle && !this.closest('#CartDrawer')) {
        panelToggle.addEventListener('click', function () {
          var panel = this.closest('[data-panel]');
          var open = !panel.classList.contains('cart-block-panel--open');
          panel.classList.toggle('cart-block-panel--open', open);
          panel.querySelector('.cart-block-panel-body').hidden = !open;
          var expanded = open ? 'true' : 'false';
          this.setAttribute('aria-expanded', expanded);
          if (open) manager.loadHistory(this.closest('frostix-bonus-club'));
        });
      }
      manager.register(this);
    }

    disconnectedCallback() {
      manager.unregister(this);
    }
  }

  customElements.define('frostix-bonus-club', FrostixBonusClubElement);
  window.FrostixBonusClub = manager;
})();
